import React from 'react';

const Facebook = () => {
	return (
		<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.1028 11.258L23.3301 1.625H21.3801L14.2383 9.98887L8.53126 1.625H1.95001L10.5788 14.274L1.95001 24.375H3.90001L11.4433 15.5415L17.4704 24.375H24.0516L15.1028 11.258ZM12.4329 14.3845L11.5586 13.1251L4.60201 3.10375H7.59689L13.2096 11.1914L14.0839 12.4508L21.3818 22.9645H18.3869L12.4329 14.3845Z" fill="white" />
</svg>
	);
};

const TG = () => {
	return (
		<svg
			width='28'
			height='26'
			viewBox='0 0 28 26'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M26.381 2.47607L1.61905 11.3196L8.69388 14.857L19.3061 7.7822L12.2313 16.6257L22.8435 23.7006L26.381 2.47607Z'
				stroke='white'
				stroke-width='1.5'
				stroke-linejoin='round'
			/>
		</svg>
	);
};

const Discord = () => {
	return (
		<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16.0769 6.25C15.6689 6.25 15.2776 6.40804 14.9891 6.68934C14.7005 6.97064 14.5385 7.35218 14.5385 7.75C14.5385 8.14782 14.7005 8.52936 14.9891 8.81066C15.2776 9.09196 15.6689 9.25 16.0769 9.25C16.4849 9.25 16.8763 9.09196 17.1648 8.81066C17.4533 8.52936 17.6154 8.14782 17.6154 7.75C17.6154 7.35218 17.4533 6.97064 17.1648 6.68934C16.8763 6.40804 16.4849 6.25 16.0769 6.25ZM8.38462 7.75C8.38462 7.35218 8.5467 6.97064 8.83522 6.68934C9.12374 6.40804 9.51505 6.25 9.92308 6.25C10.3311 6.25 10.7224 6.40804 11.0109 6.68934C11.2995 6.97064 11.4615 7.35218 11.4615 7.75C11.4615 8.14782 11.2995 8.52936 11.0109 8.81066C10.7224 9.09196 10.3311 9.25 9.92308 9.25C9.51505 9.25 9.12374 9.09196 8.83522 8.81066C8.5467 8.52936 8.38462 8.14782 8.38462 7.75ZM13.7692 1.75C13.7692 1.55109 13.6882 1.36032 13.5439 1.21967C13.3997 1.07902 13.204 1 13 1C12.796 1 12.6003 1.07902 12.4561 1.21967C12.3118 1.36032 12.2308 1.55109 12.2308 1.75V2.5H7.61538C7.00335 2.5 6.41638 2.73705 5.9836 3.15901C5.55082 3.58097 5.30769 4.15326 5.30769 4.75V10.75C5.30769 11.3467 5.55082 11.919 5.9836 12.341C6.41638 12.7629 7.00335 13 7.61538 13H18.3846C18.9967 13 19.5836 12.7629 20.0164 12.341C20.4492 11.919 20.6923 11.3467 20.6923 10.75V4.75C20.6923 4.15326 20.4492 3.58097 20.0164 3.15901C19.5836 2.73705 18.9967 2.5 18.3846 2.5H13.7692V1.75ZM7.61538 4H18.3846C18.5886 4 18.7843 4.07902 18.9285 4.21967C19.0728 4.36032 19.1538 4.55109 19.1538 4.75V10.75C19.1538 10.9489 19.0728 11.1397 18.9285 11.2803C18.7843 11.421 18.5886 11.5 18.3846 11.5H7.61538C7.41137 11.5 7.21572 11.421 7.07146 11.2803C6.9272 11.1397 6.84615 10.9489 6.84615 10.75V4.75C6.84615 4.55109 6.9272 4.36032 7.07146 4.21967C7.21572 4.07902 7.41137 4 7.61538 4ZM13.3846 24.997C17.4092 24.9475 19.8385 24.1045 21.2646 22.837C22.6108 21.637 22.94 20.1715 22.9923 19.003H23V17.968C22.9996 17.2482 22.706 16.558 22.1839 16.0492C21.6617 15.5403 20.9536 15.2545 20.2154 15.2545H15.3077V15.25H10.6923V15.2545H5.78462C4.24615 15.2545 3 16.4695 3 17.9695V19.003H3.00769C3.06 20.173 3.38923 21.6385 4.73538 22.8355C6.16154 24.1045 8.59077 24.9475 12.6154 24.997V25H13.3846V24.997ZM5.78462 16.7545H20.2154C20.5459 16.7545 20.8629 16.8825 21.0965 17.1104C21.3302 17.3382 21.4615 17.6473 21.4615 17.9695V18.625C21.4615 19.66 21.26 20.809 20.2277 21.7285C19.1692 22.669 17.0923 23.5 13 23.5C8.90769 23.5 6.83077 22.669 5.77231 21.7285C4.74154 20.809 4.53846 19.6585 4.53846 18.625V17.968C4.53887 17.646 4.67034 17.3374 4.904 17.1098C5.13765 16.8823 5.45438 16.7545 5.78462 16.7545Z" fill="white" />
</svg>
	);
};

const Hamburger = () => {
	return (
		<svg
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M7 18H21M7 12H21M7 6H21'
				stroke='#ea580c'
				stroke-width='1.5'
				stroke-linecap='round'
			/>
			<path
				d='M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12Z'
				fill='#ea580c'
			/>
			<path
				d='M5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6Z'
				fill='#ea580c'
			/>
			<path
				d='M5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z'
				fill='#ea580c'
			/>
		</svg>
	);
};

const Logo = () => {
	return (
		<svg width="103" height="20" viewBox="0 0 103 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.107422H13.5868V4.57836H9.42428V19.8737H4.31931V4.57836H0V0.107422Z" fill="white" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M52.2178 0.107422H65.8046V4.57836H61.6421V19.8737H56.5371V4.57836H52.2178V0.107422Z" fill="white" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M44.562 0.143555H34.7449L34.7384 19.7759L40.086 19.8296V13.2405H43.8557C43.8557 13.2405 49.5098 13.0837 49.8242 8.3772V5.39689C49.8247 5.39736 50.4522 1.31832 44.562 0.143555ZM44.4053 5.82845V7.3186C44.4053 8.77004 42.6777 9.00518 42.6777 9.00518H40.1252L40.086 4.2991H42.6777C44.6022 4.80904 44.4053 5.82845 44.4053 5.82845Z" fill="white" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M96.7799 0.143555H86.9628L86.9563 19.7759L92.3039 19.8296V13.2405H96.0736C96.0736 13.2405 101.728 13.0837 102.042 8.3772V5.39689C102.043 5.39736 102.67 1.31832 96.7799 0.143555ZM96.6232 5.82845V7.3186C96.6232 8.77004 94.8956 9.00518 94.8956 9.00518H92.3431L92.3039 4.2991H94.8956C96.8201 4.80904 96.6232 5.82845 96.6232 5.82845Z" fill="white" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2557 17.5702L16.7323 20L22.6224 9.64822L28.1982 19.8432L32.6752 17.5702L22.5436 0L12.2557 17.5702Z" fill="white" fill-opacity="0.66" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M64.4736 17.5702L68.9502 20L74.8403 9.64822L80.4161 19.8432L84.8931 17.5702L74.7615 0L64.4736 17.5702Z" fill="white" fill-opacity="0.66" />
</svg>
	)
}

const MacroChip = () => {
	return (
		<svg
			width='569'
			height='453'
			viewBox='0 0 569 453'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g opacity='0.12'>
				<g filter='url(#filter0_bi_1648_1693)'>
					<path
						d='M260.357 131.834C287.263 123.806 316.379 128.915 338.945 145.624L520.254 279.87C537.63 292.735 532.86 319.917 512.142 326.098L295.96 390.597C269.054 398.625 239.938 393.516 217.372 376.808L36.0637 242.562C18.6875 229.696 23.4569 202.515 44.1752 196.333L260.357 131.834Z'
						fill='#E4E8F3'
						fill-opacity='0.4'
					/>
				</g>
				<g filter='url(#filter1_bi_1648_1693)'>
					<path
						d='M25.834 216.941L23.5667 229.862C21.9703 239.029 25.125 249.024 33.8023 255.449L214.657 392.279C237.223 408.988 266.339 414.097 293.246 406.069L509.881 338.985C520.227 335.899 526.596 327.575 528.216 318.412L530.473 305.547C528.847 314.701 522.48 323.014 512.142 326.098L295.96 390.597C269.054 398.625 239.938 393.516 217.372 376.808L36.0636 242.562C27.3755 236.129 24.2239 226.117 25.834 216.941Z'
						fill='#E4E8F3'
						fill-opacity='0.4'
					/>
				</g>
				<g filter='url(#filter2_f_1648_1693)'>
					<path
						d='M295.961 390.598L512.142 326.098C521.573 323.285 527.699 316.12 529.936 307.935C521.955 319.969 519.455 320.342 511.503 323.362L296.016 386.669C289.926 388.207 273.428 392.088 254.751 388.811C236.073 385.534 222.954 376.456 218.412 373.052C160.318 329.969 42.1063 244.167 36.5448 239.822C30.9833 235.477 26.8656 227.158 25.5019 223.542C26.0274 230.659 29.4334 237.653 36.0639 242.562L217.372 376.808C239.938 393.516 269.054 398.625 295.961 390.598Z'
						fill='url(#paint0_linear_1648_1693)'
					/>
				</g>
			</g>
			<g opacity='0.52'>
				<g filter='url(#filter3_bi_1648_1693)'>
					<path
						d='M275.303 46.6557C302.21 38.628 331.325 43.7368 353.892 60.4454L535.2 194.691C552.576 207.557 547.807 234.738 527.088 240.92L310.907 305.419C284 313.447 254.884 308.338 232.318 291.629L51.0099 157.383C33.6338 144.518 38.4032 117.336 59.1215 111.155L275.303 46.6557Z'
						fill='#E4E8F3'
						fill-opacity='0.4'
					/>
				</g>
				<g filter='url(#filter4_bi_1648_1693)'>
					<path
						d='M40.7812 131.763L38.514 144.684C36.9176 153.851 40.0722 163.846 48.7495 170.271L229.604 307.101C252.171 323.809 281.286 328.918 308.193 320.89L524.828 253.807C535.174 250.72 541.543 242.396 543.163 233.233L545.421 220.368C543.794 229.522 537.427 237.835 527.089 240.92L310.908 305.419C284.001 313.447 254.885 308.338 232.319 291.629L51.0109 157.384C42.3228 150.951 39.1711 140.939 40.7812 131.763Z'
						fill='#E4E8F3'
						fill-opacity='0.4'
					/>
				</g>
				<g filter='url(#filter5_f_1648_1693)'>
					<path
						d='M310.906 305.419L527.088 240.92C536.518 238.106 542.644 230.941 544.882 222.756C536.9 234.79 534.4 235.163 526.448 238.183L310.961 301.49C304.872 303.029 288.373 306.91 269.696 303.632C251.019 300.355 237.899 291.277 233.357 287.873C175.263 244.79 57.0515 158.988 51.49 154.643C45.9285 150.298 41.8107 141.98 40.447 138.364C40.9726 145.48 44.3785 152.474 51.0091 157.383L232.317 291.629C254.884 308.338 283.999 313.447 310.906 305.419Z'
						fill='url(#paint1_linear_1648_1693)'
					/>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_bi_1648_1693'
					x='5.42944'
					y='108.11'
					width='545.458'
					height='306.212'
					filterUnits='userSpaceOnUse'
					color-interpolation-filters='sRGB'
				>
					<feFlood flood-opacity='0' result='BackgroundImageFix' />
					<feGaussianBlur in='BackgroundImageFix' stdDeviation='10' />
					<feComposite
						in2='SourceAlpha'
						operator='in'
						result='effect1_backgroundBlur_1648_1693'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_backgroundBlur_1648_1693'
						result='shape'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='0.5' />
					<feGaussianBlur stdDeviation='0.5' />
					<feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0'
					/>
					<feBlend mode='darken' in2='shape' result='effect2_innerShadow_1648_1693' />
				</filter>
				<filter
					id='filter1_bi_1648_1693'
					x='3.16797'
					y='196.941'
					width='547.305'
					height='232.852'
					filterUnits='userSpaceOnUse'
					color-interpolation-filters='sRGB'
				>
					<feFlood flood-opacity='0' result='BackgroundImageFix' />
					<feGaussianBlur in='BackgroundImageFix' stdDeviation='10' />
					<feComposite
						in2='SourceAlpha'
						operator='in'
						result='effect1_backgroundBlur_1648_1693'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_backgroundBlur_1648_1693'
						result='shape'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='-0.5' />
					<feGaussianBlur stdDeviation='0.5' />
					<feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0'
					/>
					<feBlend mode='darken' in2='shape' result='effect2_innerShadow_1648_1693' />
				</filter>
				<filter
					id='filter2_f_1648_1693'
					x='24.5018'
					y='222.542'
					width='506.435'
					height='172.779'
					filterUnits='userSpaceOnUse'
					color-interpolation-filters='sRGB'
				>
					<feFlood flood-opacity='0' result='BackgroundImageFix' />
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='BackgroundImageFix'
						result='shape'
					/>
					<feGaussianBlur stdDeviation='0.5' result='effect1_foregroundBlur_1648_1693' />
				</filter>
				<filter
					id='filter3_bi_1648_1693'
					x='20.3757'
					y='22.9314'
					width='545.458'
					height='306.212'
					filterUnits='userSpaceOnUse'
					color-interpolation-filters='sRGB'
				>
					<feFlood flood-opacity='0' result='BackgroundImageFix' />
					<feGaussianBlur in='BackgroundImageFix' stdDeviation='10' />
					<feComposite
						in2='SourceAlpha'
						operator='in'
						result='effect1_backgroundBlur_1648_1693'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_backgroundBlur_1648_1693'
						result='shape'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='0.5' />
					<feGaussianBlur stdDeviation='0.5' />
					<feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0'
					/>
					<feBlend mode='darken' in2='shape' result='effect2_innerShadow_1648_1693' />
				</filter>
				<filter
					id='filter4_bi_1648_1693'
					x='18.1152'
					y='111.763'
					width='547.305'
					height='232.852'
					filterUnits='userSpaceOnUse'
					color-interpolation-filters='sRGB'
				>
					<feFlood flood-opacity='0' result='BackgroundImageFix' />
					<feGaussianBlur in='BackgroundImageFix' stdDeviation='10' />
					<feComposite
						in2='SourceAlpha'
						operator='in'
						result='effect1_backgroundBlur_1648_1693'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_backgroundBlur_1648_1693'
						result='shape'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='-0.5' />
					<feGaussianBlur stdDeviation='0.5' />
					<feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0'
					/>
					<feBlend mode='darken' in2='shape' result='effect2_innerShadow_1648_1693' />
				</filter>
				<filter
					id='filter5_f_1648_1693'
					x='39.447'
					y='137.364'
					width='506.435'
					height='172.779'
					filterUnits='userSpaceOnUse'
					color-interpolation-filters='sRGB'
				>
					<feFlood flood-opacity='0' result='BackgroundImageFix' />
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='BackgroundImageFix'
						result='shape'
					/>
					<feGaussianBlur stdDeviation='0.5' result='effect1_foregroundBlur_1648_1693' />
				</filter>
				<linearGradient
					id='paint0_linear_1648_1693'
					x1='26.2031'
					y1='219.546'
					x2='529.937'
					y2='307.935'
					gradientUnits='userSpaceOnUse'
				>
					<stop stop-color='white' stop-opacity='0.24' />
					<stop offset='0.130208' stop-color='white' stop-opacity='0.865636' />
					<stop offset='0.489583' stop-color='white' stop-opacity='0.494792' />
					<stop offset='1' stop-color='white' stop-opacity='0' />
				</linearGradient>
				<linearGradient
					id='paint1_linear_1648_1693'
					x1='41.1483'
					y1='134.367'
					x2='544.882'
					y2='222.756'
					gradientUnits='userSpaceOnUse'
				>
					<stop stop-color='white' stop-opacity='0.24' />
					<stop offset='0.130208' stop-color='white' stop-opacity='0.865636' />
					<stop offset='0.489583' stop-color='white' stop-opacity='0.494792' />
					<stop offset='1' stop-color='white' stop-opacity='0' />
				</linearGradient>
			</defs>
		</svg>
	);
};

const MicroChip = () => {
	return (
		<svg
			width='205'
			height='163'
			viewBox='0 0 205 163'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g opacity='0.44'>
				<g opacity='0.1'>
					<g filter='url(#filter0_bi_1648_1702)'>
						<path
							d='M110.763 47.3805C101.093 44.4953 90.6288 46.3314 82.5186 52.3364L17.3573 100.584C11.1124 105.208 12.8265 114.976 20.2726 117.198L97.9672 140.379C107.637 143.264 118.101 141.428 126.211 135.423L191.373 87.1755C197.618 82.5516 195.904 72.7828 188.458 70.5612L110.763 47.3805Z'
							fill='#E4E8F3'
							fill-opacity='0.4'
						/>
					</g>
					<g filter='url(#filter1_bi_1648_1702)'>
						<path
							d='M195.05 77.9675L195.864 82.6114C196.438 85.9059 195.304 89.4981 192.186 91.8072L127.187 140.983C119.077 146.988 108.613 148.824 98.9432 145.939L21.0856 121.83C17.3672 120.72 15.0782 117.729 14.496 114.436L13.6847 109.812C14.2692 113.102 16.5575 116.089 20.2729 117.198L97.9675 140.379C107.638 143.264 118.102 141.428 126.212 135.423L191.373 87.1755C194.496 84.8636 195.628 81.2654 195.05 77.9675Z'
							fill='#E4E8F3'
							fill-opacity='0.4'
						/>
					</g>
					<g filter='url(#filter2_f_1648_1702)'>
						<path
							d='M97.9672 140.379L20.2726 117.198C16.8833 116.187 14.6816 113.612 13.8775 110.67C16.7462 114.995 17.6445 115.129 20.5025 116.214L97.9475 138.967C100.136 139.52 106.065 140.914 112.778 139.737C119.49 138.559 124.205 135.296 125.838 134.073C146.716 118.589 189.201 87.7522 191.2 86.1906C193.199 84.629 194.679 81.6395 195.169 80.3399C194.98 82.8975 193.756 85.4111 191.373 87.1755L126.212 135.423C118.101 141.428 107.637 143.264 97.9672 140.379Z'
							fill='url(#paint0_linear_1648_1702)'
						/>
					</g>
				</g>
				<g opacity='0.44'>
					<g filter='url(#filter3_bi_1648_1702)'>
						<path
							d='M105.392 16.7679C95.7217 13.8828 85.2576 15.7189 77.1474 21.7239L11.9861 69.9711C5.7412 74.595 7.4553 84.3638 14.9014 86.5854L92.5959 109.766C102.266 112.651 112.73 110.815 120.84 104.81L186.002 56.5629C192.246 51.9391 190.532 42.1702 183.086 39.9486L105.392 16.7679Z'
							fill='#E4E8F3'
							fill-opacity='0.4'
						/>
					</g>
					<g filter='url(#filter4_bi_1648_1702)'>
						<path
							d='M189.678 47.355L190.493 51.9988C191.067 55.2934 189.933 58.8855 186.815 61.1946L121.816 110.371C113.706 116.376 103.242 118.212 93.572 115.327L15.7144 91.2171C11.996 90.1077 9.707 87.1161 9.12482 83.823L8.31352 79.1993C8.89797 82.4893 11.1862 85.4769 14.9017 86.5855L92.5963 109.766C102.266 112.651 112.73 110.815 120.841 104.81L186.002 56.563C189.124 54.2511 190.257 50.6529 189.678 47.355Z'
							fill='#E4E8F3'
							fill-opacity='0.4'
						/>
					</g>
					<g filter='url(#filter5_f_1648_1702)'>
						<path
							d='M92.596 109.766L14.9014 86.5854C11.5121 85.5742 9.31034 82.9992 8.50631 80.0575C11.3749 84.3825 12.2733 84.5165 15.1312 85.6019L92.5763 108.354C94.7647 108.907 100.694 110.302 107.407 109.124C114.119 107.946 118.834 104.684 120.467 103.46C141.345 87.9765 183.83 57.1396 185.829 55.578C187.828 54.0164 189.308 51.0269 189.798 49.7274C189.609 52.2849 188.385 54.7985 186.002 56.5629L120.84 104.81C112.73 110.815 102.266 112.651 92.596 109.766Z'
							fill='url(#paint1_linear_1648_1702)'
						/>
					</g>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_bi_1648_1702'
					x='-6.4646'
					y='26.042'
					width='221.659'
					height='135.675'
					filterUnits='userSpaceOnUse'
					color-interpolation-filters='sRGB'
				>
					<feFlood flood-opacity='0' result='BackgroundImageFix' />
					<feGaussianBlur in='BackgroundImageFix' stdDeviation='10' />
					<feComposite
						in2='SourceAlpha'
						operator='in'
						result='effect1_backgroundBlur_1648_1702'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_backgroundBlur_1648_1702'
						result='shape'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='0.5' />
					<feGaussianBlur stdDeviation='0.5' />
					<feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0'
					/>
					<feBlend mode='darken' in2='shape' result='effect2_innerShadow_1648_1702' />
				</filter>
				<filter
					id='filter1_bi_1648_1702'
					x='-6.31526'
					y='57.9675'
					width='222.323'
					height='109.31'
					filterUnits='userSpaceOnUse'
					color-interpolation-filters='sRGB'
				>
					<feFlood flood-opacity='0' result='BackgroundImageFix' />
					<feGaussianBlur in='BackgroundImageFix' stdDeviation='10' />
					<feComposite
						in2='SourceAlpha'
						operator='in'
						result='effect1_backgroundBlur_1648_1702'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_backgroundBlur_1648_1702'
						result='shape'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='-0.5' />
					<feGaussianBlur stdDeviation='0.5' />
					<feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0'
					/>
					<feBlend mode='darken' in2='shape' result='effect2_innerShadow_1648_1702' />
				</filter>
				<filter
					id='filter2_f_1648_1702'
					x='12.8775'
					y='79.3398'
					width='183.291'
					height='63.3774'
					filterUnits='userSpaceOnUse'
					color-interpolation-filters='sRGB'
				>
					<feFlood flood-opacity='0' result='BackgroundImageFix' />
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='BackgroundImageFix'
						result='shape'
					/>
					<feGaussianBlur stdDeviation='0.5' result='effect1_foregroundBlur_1648_1702' />
				</filter>
				<filter
					id='filter3_bi_1648_1702'
					x='-11.8358'
					y='-4.57056'
					width='221.659'
					height='135.675'
					filterUnits='userSpaceOnUse'
					color-interpolation-filters='sRGB'
				>
					<feFlood flood-opacity='0' result='BackgroundImageFix' />
					<feGaussianBlur in='BackgroundImageFix' stdDeviation='10' />
					<feComposite
						in2='SourceAlpha'
						operator='in'
						result='effect1_backgroundBlur_1648_1702'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_backgroundBlur_1648_1702'
						result='shape'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='0.5' />
					<feGaussianBlur stdDeviation='0.5' />
					<feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0'
					/>
					<feBlend mode='darken' in2='shape' result='effect2_innerShadow_1648_1702' />
				</filter>
				<filter
					id='filter4_bi_1648_1702'
					x='-11.6865'
					y='27.355'
					width='222.323'
					height='109.31'
					filterUnits='userSpaceOnUse'
					color-interpolation-filters='sRGB'
				>
					<feFlood flood-opacity='0' result='BackgroundImageFix' />
					<feGaussianBlur in='BackgroundImageFix' stdDeviation='10' />
					<feComposite
						in2='SourceAlpha'
						operator='in'
						result='effect1_backgroundBlur_1648_1702'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_backgroundBlur_1648_1702'
						result='shape'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='-0.5' />
					<feGaussianBlur stdDeviation='0.5' />
					<feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0'
					/>
					<feBlend mode='darken' in2='shape' result='effect2_innerShadow_1648_1702' />
				</filter>
				<filter
					id='filter5_f_1648_1702'
					x='7.5063'
					y='48.7273'
					width='183.291'
					height='63.3774'
					filterUnits='userSpaceOnUse'
					color-interpolation-filters='sRGB'
				>
					<feFlood flood-opacity='0' result='BackgroundImageFix' />
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='BackgroundImageFix'
						result='shape'
					/>
					<feGaussianBlur stdDeviation='0.5' result='effect1_foregroundBlur_1648_1702' />
				</filter>
				<linearGradient
					id='paint0_linear_1648_1702'
					x1='194.917'
					y1='78.9036'
					x2='13.8774'
					y2='110.67'
					gradientUnits='userSpaceOnUse'
				>
					<stop stop-color='white' stop-opacity='0.24' />
					<stop offset='0.130208' stop-color='white' stop-opacity='0.865636' />
					<stop offset='0.489583' stop-color='white' stop-opacity='0.494792' />
					<stop offset='1' stop-color='white' stop-opacity='0' />
				</linearGradient>
				<linearGradient
					id='paint1_linear_1648_1702'
					x1='189.546'
					y1='48.291'
					x2='8.50622'
					y2='80.0575'
					gradientUnits='userSpaceOnUse'
				>
					<stop stop-color='white' stop-opacity='0.24' />
					<stop offset='0.130208' stop-color='white' stop-opacity='0.865636' />
					<stop offset='0.489583' stop-color='white' stop-opacity='0.494792' />
					<stop offset='1' stop-color='white' stop-opacity='0' />
				</linearGradient>
			</defs>
		</svg>
	);
};

const Rocket = () => {
	return (
		<svg
			width='25'
			height='24'
			viewBox='0 0 25 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M3.38148 11.096L6.71554 12.5083C7.1374 11.663 7.59691 10.845 8.09407 10.0542C8.59124 9.26335 9.14011 8.49434 9.74069 7.74711L7.6518 7.34671C7.51209 7.3113 7.37691 7.31538 7.24627 7.35897C7.11563 7.40255 6.99769 7.47654 6.89245 7.58095L3.38148 11.096ZM7.79333 13.3717L11.6445 17.2205C12.7196 16.7347 13.8014 16.1173 14.8901 15.3683C15.9788 14.6192 17.0257 13.7417 18.0309 12.7357C19.4961 11.2694 20.6156 9.70552 21.3895 8.044C22.1634 6.38248 22.5984 4.46402 22.6946 2.28862C20.5208 2.38486 18.6066 2.82021 16.9518 3.59468C15.2988 4.36915 13.7393 5.48953 12.2732 6.95584C11.2689 7.96183 10.3925 9.01367 9.64407 10.1114C8.89561 11.2091 8.27869 12.2958 7.79333 13.3717ZM14.8425 10.1372C14.4433 9.73775 14.2437 9.25836 14.2437 8.69907C14.2437 8.13979 14.4433 7.65994 14.8425 7.25955C15.2417 6.85915 15.727 6.6594 16.2986 6.66031C16.8701 6.66122 17.3551 6.86096 17.7533 7.25955C18.1516 7.65813 18.3512 8.13797 18.3521 8.69907C18.353 9.26018 18.1534 9.73956 17.7533 10.1372C17.3542 10.5367 16.8688 10.7365 16.2972 10.7365C15.7257 10.7365 15.2412 10.5367 14.8439 10.1372M13.8926 21.6439L17.405 18.1289C17.5093 18.0235 17.5837 17.9055 17.6281 17.7748C17.6717 17.644 17.6762 17.5087 17.6417 17.3689L17.2403 15.2784C16.4936 15.8795 15.7252 16.4274 14.935 16.9222C14.1448 17.417 13.3274 17.8755 12.4828 18.2977L13.8926 21.6439ZM23.9656 1.03431C24.118 3.53657 23.7642 5.83818 22.9041 7.93913C22.045 10.041 20.7068 12.0012 18.8896 13.8198L18.6529 14.0554L18.4174 14.291L18.9672 17.0856C19.0407 17.4524 19.0271 17.8079 18.9264 18.152C18.8248 18.4961 18.6415 18.8007 18.3766 19.0658L13.4204 24L11.1641 18.6818L6.31409 13.828L1 11.5441L5.92217 6.60992C6.18708 6.34481 6.49282 6.15732 6.83938 6.04746C7.18594 5.9376 7.54248 5.91944 7.909 5.99298L10.7532 6.5677C10.8403 6.48054 10.9142 6.40201 10.975 6.33209C11.0358 6.26218 11.1102 6.18365 11.1982 6.09649C13.0162 4.27699 14.9736 2.94051 17.0702 2.08706C19.1668 1.2336 21.4644 0.882686 23.9656 1.03431ZM3.28349 17.8374C3.81604 17.3054 4.46289 17.0421 5.22406 17.0475C5.98522 17.053 6.63207 17.3226 7.16462 17.8565C7.69716 18.3903 7.96207 19.0377 7.95935 19.7985C7.95663 20.5612 7.689 21.2086 7.15645 21.7406C6.69377 22.2037 5.95211 22.6 4.93148 22.9295C3.91084 23.2591 2.72918 23.487 1.38648 23.6132C1.51258 22.2695 1.74483 21.0869 2.08323 20.0655C2.42163 19.0441 2.82172 18.3014 3.28349 17.8374ZM4.25514 18.8275C3.99295 19.0899 3.74845 19.5175 3.52164 20.1104C3.29483 20.7033 3.14514 21.3148 3.07256 21.9449C3.70218 21.8714 4.3132 21.7179 4.90562 21.4846C5.49713 21.2521 5.92398 21.0047 6.18617 20.7423C6.45834 20.47 6.59715 20.1454 6.60259 19.7686C6.60713 19.3909 6.47331 19.0658 6.20114 18.7935C5.92897 18.5211 5.60464 18.3908 5.22814 18.4026C4.85164 18.4135 4.5273 18.5551 4.25514 18.8275Z'
				fill='#0E0B3D'
			/>
		</svg>
	);
};

const About1 = () => {
	return (
	  <svg
		width="68"
		height="60"
		viewBox="0 0 68 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		role="img"
		aria-label="Top layer slides up; profile icon flies out and fades"
	  >
		{/* --- НИЖНИЕ СЛОИ (без изменений) --- */}
		<g filter="url(#filter0_i_1802_1895)">
		  <path d="M66.1167 53.3203V55.6116C66.1167 57.8842 63.8174 59.9998 60.5224 59.9998H7.3257C3.95351 59.9998 1.73346 57.7684 1.73346 55.4521L1.7335 53.3678L66.1167 53.3203Z" fill="url(#paint0_linear_1802_1895)"/>
		</g>
		<g filter="url(#filter1_i_1802_1895)">
		  <path d="M29.4974 23.43C31.7327 21.1376 36.1149 21.1376 38.3503 23.43L64.9487 50.7079C67.7731 53.6045 65.1551 57.7977 60.5222 57.7977H7.32545C2.69258 57.7977 0.0745815 53.6045 2.899 50.7079L29.4974 23.43Z" fill="url(#paint1_radial_1802_1895)"/>
		</g>
		<g filter="url(#filter2_f_1802_1895)">
		  <path d="M1.74218 53.0994C1.54965 55.4793 3.88054 57.798 7.32556 57.798H60.5223C63.9673 57.798 66.2982 55.4793 66.1057 53.0994C65.9307 55.2738 63.7006 57.3878 60.5223 57.3878H7.32556C4.14722 57.3878 1.91721 55.2738 1.74218 53.0994Z" fill="url(#paint2_linear_1802_1895)"/>
		</g>
		<g filter="url(#filter3_bi_1802_1895)">
		  <path d="M1.7335 42.6428L1.73346 44.5968C1.73346 46.9131 3.95351 49.1445 7.3257 49.1445H60.5224C63.8174 49.1445 66.1167 47.0289 66.1167 44.7563V42.5579C66.0907 44.8236 63.8156 46.9422 60.5225 46.9422H7.32574C4.07378 46.9422 1.81457 44.8762 1.7335 42.6428Z" fill="#E4E8F3" fillOpacity="0.4"/>
		  <path d="M66.1167 42.465V42.4792C66.1167 42.4745 66.1168 42.4697 66.1167 42.465Z" fill="#E4E8F3" fillOpacity="0.4"/>
		</g>
		<g filter="url(#filter4_bi_1802_1895)">
		  <path d="M29.4974 12.5747C31.7327 10.2822 36.1149 10.2822 38.3503 12.5747L64.9487 39.8526C67.7731 42.7491 65.1551 46.9424 60.5222 46.9424H7.32545C2.69258 46.9424 0.0745815 42.7491 2.899 39.8526L29.4974 12.5747Z" fill="#E4E8F3" fillOpacity="0.4"/>
		</g>
		<g filter="url(#filter5_f_1802_1895)">
		  <path d="M1.74218 42.2439C1.54965 44.6239 3.88054 46.9425 7.32556 46.9425H60.5223C63.9673 46.9425 66.2982 44.6239 66.1057 42.2439C65.9307 44.4184 63.7006 46.5323 60.5223 46.5323H7.32556C4.14722 46.5323 1.91721 44.4184 1.74218 42.2439Z" fill="url(#paint3_linear_1802_1895)"/>
		</g>
		<g filter="url(#filter6_bi_1802_1895)">
		  <path d="M1.73271 31.7879L1.73267 33.7419C1.73266 36.0583 3.95271 38.2897 7.3249 38.2897H60.5217C63.8167 38.2897 66.116 36.174 66.116 33.9014V31.7031C66.0899 33.9687 63.8148 36.0874 60.5217 36.0874H7.32494C4.07299 36.0874 1.81377 34.0213 1.73271 31.7879Z" fill="#E4E8F3" fillOpacity="0.4"/>
		  <path d="M66.116 31.6101V31.6243C66.1159 31.6196 66.116 31.6149 66.116 31.6101Z" fill="#E4E8F3" fillOpacity="0.4"/>
		</g>
  
		{/* === ВЕРХНИЙ СЛОЙ (крышка) — прямой подъем/спуск === */}
		<g id="lidGroup">
		  <g clipPath="url(#lidClip)">
			{/* крышка */}
			<path
			  d="M29.4974 1.71934C31.7327 -0.573109 36.1149 -0.573117 38.3503 1.71934L64.9487 28.9974C67.7731 31.8939 65.1551 36.0872 60.5222 36.0872H7.32545C2.69258 36.0872 0.0745815 31.8939 2.899 28.9974L29.4974 1.71934Z"
			  fill="#E4E8F3"
			  fillOpacity="0.4"
			/>
			{/* световой кант */}
			<path
			  d="M1.74193 31.3886C1.5494 33.7685 3.8803 36.0872 7.32532 36.0872H60.5221C63.9671 36.0872 66.298 33.7685 66.1055 31.3885C65.9305 33.563 63.7004 35.677 60.5221 35.677H7.32532C4.14698 35.677 1.91697 33.563 1.74193 31.3886Z"
			  fill="url(#paint4_linear_1802_1895)"
			/>
		  </g>
  
		  {/* движение крышки: 0→-12 (0.6с), держим, опускаем, пауза ~5с */}
		  <animateTransform
			attributeName="transform"
			type="translate"
			dur="7.6s"
			repeatCount="indefinite"
			keyTimes="0;0.079;0.211;0.263;0.342;1"
			values="0 0; 0 -12; 0 -12; 0 -12; 0 0; 0 0"
		  />
		</g>
  
		{/* === БОЛЬШАЯ ИКОНКА ПРОФИЛЯ — вылетает и растворяется === */}
		{/* Базовая позиция иконки (примерно над верхом коробки) */}
		<g id="flyProfile" filter="url(#pfShadow)" opacity="0">
		  {/* Трансляция (вылет вверх) */}
		  <animateTransform
			attributeName="transform"
			type="translate"
			dur="7.6s"
			repeatCount="indefinite"
			keyTimes="0;0.079;0.16;0.263;1"
			values="0 0; 0 0; 0 -8; 0 -16; 0 -16"
		  />
		  {/* Прозрачность: появление → удержание → растворение */}
		  <animate
			attributeName="opacity"
			dur="7.6s"
			repeatCount="indefinite"
			keyTimes="0;0.09;0.18;0.30;1"
			values="0;1;1;0;0"
		  />
		  {/* Слегка увеличиваемся в полёте (внутренний масштаб) */}
		  <g>
			<animateTransform
			  attributeName="transform"
			  type="scale"
			  dur="7.6s"
			  repeatCount="indefinite"
			  keyTimes="0;0.09;0.21;0.30;1"
			  values="1;1.05;1.12;1.12;1.12"
			  additive="replace"
			/>
			{/* круглая «плашка» */}
			<circle cx="34" cy="14" r="10.5" fill="url(#pfBgGrad)" />
			<circle cx="34" cy="14" r="10.5" fill="none" stroke="white" strokeOpacity="0.35" strokeWidth="0.8"/>
			{/* силуэт пользователя (голова+плечи) */}
			<g fill="none" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
			  {/* голова */}
			  <circle cx="34" cy="12" r="3.4" />
			  {/* плечи/торс */}
			  <path d="M26.8 19.2c1.8-3.2 4.7-4.8 7.2-4.8s5.4 1.6 7.2 4.8" />
			</g>
		  </g>
		</g>
  
		{/* === defs === */}
		<defs>
		  {/* клип формы крышки (оставлен на случай будущих вставок) */}
		  <clipPath id="lidClip">
			<path d="M29.4974 1.71934C31.7327 -0.573109 36.1149 -0.573117 38.3503 1.71934L64.9487 28.9974C67.7731 31.8939 65.1551 36.0872 60.5222 36.0872H7.32545C2.69258 36.0872 0.0745815 31.8939 2.899 28.9974L29.4974 1.71934Z" />
		  </clipPath>
  
		  {/* фон плашки профиля + тень */}
		  <radialGradient id="pfBgGrad" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
			gradientTransform="translate(28 10) rotate(35) scale(18)">
			<stop stopColor="#ff8a3d"/>
			<stop offset="1" stopColor="#ffffff"/>
		  </radialGradient>
		  <filter id="pfShadow" x="-20%" y="-20%" width="140%" height="140%" colorInterpolationFilters="sRGB">
			<feDropShadow dx="0" dy="2" stdDeviation="1.5" floodOpacity="0.25"/>
		  </filter>
  
		  {/* оригинальные фильтры/градиенты */}
		  <filter id="filter0_i_1802_1895" x="1.73346" y="52.8203" width="64.3833" height="7.17957" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
			<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
			<feOffset dy="-0.5"/><feGaussianBlur stdDeviation="0.5"/><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
			<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend mode="darken" in2="shape" result="effect1_innerShadow_1802_1895"/>
		  </filter>
		  <filter id="filter1_i_1802_1895" x="1.73096" y="21.7107" width="64.3857" height="36.587" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
			<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
			<feOffset dy="0.5"/><feGaussianBlur stdDeviation="0.5"/><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
			<feColorMatrix type="matrix" values="0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"/><feBlend mode="darken" in2="shape" result="effect1_innerShadow_1802_1895"/>
		  </filter>
		  <filter id="filter2_f_1802_1895" x="0.731079" y="52.0994" width="66.3857" height="6.69861" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
			<feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_1802_1895"/>
		  </filter>
		  <filter id="filter3_bi_1802_1895" x="-18.2665" y="22.465" width="104.383" height="46.6796" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="10"/>
			<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1802_1895"/>
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1802_1895" result="shape"/>
			<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"/>
			<feBlend mode="darken" in2="shape" result="effect2_innerShadow_1802_1895"/>
		  </filter>
		  <filter id="filter4_bi_1802_1895" x="-18.269" y="-9.14465" width="104.386" height="76.087" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="10"/>
			<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1802_1895"/>
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1802_1895" result="shape"/>
			<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"/>
			<feBlend mode="darken" in2="shape" result="effect2_innerShadow_1802_1895"/>
		  </filter>
		  <filter id="filter5_f_1802_1895" x="0.731079" y="41.2439" width="66.3857" height="6.69861" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
			<feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_1802_1895"/>
		  </filter>
		  <filter id="filter6_bi_1802_1895" x="-18.2673" y="11.6101" width="104.383" height="46.6796" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="10"/>
			<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1802_1895"/>
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1802_1895" result="shape"/>
			<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"/>
			<feBlend mode="darken" in2="shape" result="effect2_innerShadow_1802_1895"/>
		  </filter>
		  <filter id="filter8_f_1802_1895" x="0.730835" y="30.3885" width="66.3857" height="6.69861" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
			<feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_1802_1895"/>
		  </filter>
		  <linearGradient id="paint0_linear_1802_1895" x1="1.73346" y1="56.6601" x2="66.1167" y2="56.6601" gradientUnits="userSpaceOnUse">
			<stop stopColor="#ff8a3d"/><stop offset="1" stopColor="#6b7280"/>
		  </linearGradient>
		  <radialGradient id="paint1_radial_1802_1895" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(3.12504 39.7542) scale(52.2223 53.0674)">
			<stop stopColor="#ff8a3d"/><stop offset="1" stopColor="white"/>
		  </radialGradient>
		  <linearGradient id="paint2_linear_1802_1895" x1="-0.219636" y1="43.6884" x2="68.0678" y2="43.6884" gradientUnits="userSpaceOnUse">
			<stop stopColor="white" stopOpacity="0.24"/><stop offset="0.130208" stopColor="white" stopOpacity="0.865636"/><stop offset="0.489583" stopColor="white" stopOpacity="0.494792"/><stop offset="1" stopColor="white" stopOpacity="0"/>
		  </linearGradient>
		  <linearGradient id="paint3_linear_1802_1895" x1="-0.219636" y1="32.8329" x2="68.0678" y2="32.8329" gradientUnits="userSpaceOnUse">
			<stop stopColor="white" stopOpacity="0.24"/><stop offset="0.130208" stopColor="white" stopOpacity="0.865636"/><stop offset="0.489583" stopColor="white" stopOpacity="0.494792"/><stop offset="1" stopColor="white" stopOpacity="0"/>
		  </linearGradient>
		  <linearGradient id="paint4_linear_1802_1895" x1="-0.21988" y1="21.9775" x2="68.0675" y2="21.9775" gradientUnits="userSpaceOnUse">
			<stop stopColor="white" stopOpacity="0.24"/><stop offset="0.130208" stopColor="white" stopOpacity="0.865636"/><stop offset="0.489583" stopColor="white" stopOpacity="0.494792"/><stop offset="1" stopColor="white" stopOpacity="0"/>
		  </linearGradient>
		</defs>
	  </svg>
	);
  };
  
  
  
  

const About2 = () => {
	return (
	  <svg
		width="90"
		height="80"
		viewBox="0 0 59 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		role="img"
		aria-label="Scouting — Glass Globe with Axis (animated)"
	  >
		<defs>
		  <linearGradient id="brandGrad" x1="0" y1="0" x2="59" y2="60" gradientUnits="userSpaceOnUse">
			<stop stopColor="#ff8a3d" />
			<stop offset="1" stopColor="#ffffff" />
		  </linearGradient>
  
		  {/* стеклянная заливка сферы */}
		  <radialGradient id="globeFill" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
			gradientTransform="translate(21 18) rotate(45) scale(36)">
			<stop stopColor="#FFFFFF" stopOpacity="0.38" />
			<stop offset="1" stopColor="#DDE2F7" stopOpacity="0.08" />
		  </radialGradient>
  
		  {/* штрих стекла */}
		  <linearGradient id="globeStroke" x1="12" y1="8" x2="46" y2="52" gradientUnits="userSpaceOnUse">
			<stop stopColor="#FFFFFF" stopOpacity="0.9" />
			<stop offset="1" stopColor="#FFFFFF" stopOpacity="0.25" />
		  </linearGradient>
  
		  {/* линии сетки меридианов/параллелей */}
		  <linearGradient id="gridLines" x1="16" y1="10" x2="44" y2="50" gradientUnits="userSpaceOnUse">
			<stop stopColor="#ea580c" />
			<stop offset="1" stopColor="#ffffff" />
		  </linearGradient>
  
		  {/* лёгкая внутренняя тень для объёма */}
		  <filter id="innerShade" x="-20%" y="-20%" width="140%" height="140%" colorInterpolationFilters="sRGB">
			<feGaussianBlur in="SourceAlpha" stdDeviation="2.2" result="b" />
			<feOffset dy="1" />
			<feComposite in2="b" operator="arithmetic" k2="-1" k3="1" />
			<feColorMatrix type="matrix" values="0 0 0 0 0.20  0 0 0 0 0.22  0 0 0 0 0.40  0 0 0 0.28 0" />
			<feBlend in="SourceGraphic" />
		  </filter>
		</defs>
  
		{/* === ОСЬ (наклонённая дуга/кольцо) — «за» сферой === */}
		<g transform="rotate(20.5 29.5 26.5)">
		  <ellipse
			cx="29.5"
			cy="26.5"
			rx="22.5"
			ry="6.4"
			fill="none"
			stroke="url(#brandGrad)"
			strokeWidth="1"
			opacity="0.18"
		  />
		</g>
  
		{/* === СФЕРА-ГЛОБУС (сам объект) === */}
		<g>
		  {/* внешняя аура (статична) */}
		  <circle cx="29.5" cy="26.5" r="22.5" fill="none" stroke="url(#brandGrad)" strokeWidth="1.2" opacity="0.22" />
  
		  {/* стеклянная сфера (статична) */}
		  <circle
			cx="29.5"
			cy="26.5"
			r="20.5"
			fill="url(#globeFill)"
			stroke="url(#globeStroke)"
			strokeWidth="1.2"
			filter="url(#innerShade)"
		  />
  
		  {/* блик (статичен) */}
		  <path
			d="M18.2 17.2c4.1-3.7 8.9-5.7 14.6-5.9"
			stroke="white"
			strokeOpacity="0.55"
			strokeWidth="1.6"
			strokeLinecap="round"
			fill="none"
		  />
  
		  {/* === ВРАЩАЕМАЯ ГРУППА: сетка + точка интереса === */}
		  <g id="globeSpin">
			{/* анимация вращения вокруг центра сферы */}
			<animateTransform
			  attributeName="transform"
			  type="rotate"
			  from="0 29.5 26.5"
			  to="360 29.5 26.5"
			  dur="8s"                 /* скорость: меньше = быстрее */
			  repeatCount="indefinite"
			/>
  
			{/* меридианы */}
			<ellipse cx="29.5" cy="26.5" rx="16.6" ry="20.2" fill="none" stroke="url(#gridLines)" strokeWidth="0.9" opacity="0.45" />
			<ellipse cx="29.5" cy="26.5" rx="8.8"  ry="20.2" fill="none" stroke="url(#gridLines)" strokeWidth="0.9" opacity="0.6" />
  
			{/* параллели */}
			<ellipse cx="29.5" cy="26.5" rx="20.2" ry="14.8" fill="none" stroke="url(#gridLines)" strokeWidth="0.9" opacity="0.45" />
			<ellipse cx="29.5" cy="26.5" rx="20.2" ry="6.2"  fill="none" stroke="url(#gridLines)" strokeWidth="1"   opacity="0.7" />
  
			{/* точка интереса (крутится вместе с сеткой) */}
			<circle cx="39.2" cy="21.4" r="2.1" fill="url(#brandGrad)" />
			<circle cx="39.2" cy="21.4" r="5" fill="none" stroke="url(#brandGrad)" strokeWidth="0.8" opacity="0.35" />
		  </g>
		</g>
  
		{/* === ОСЕВАЯ ЛИНИЯ и «передний блик» орбиты — «перед» сферой === */}
		<g transform="rotate(-23.5 29.5 26.5)" opacity="0.5">
		  <line
			x1="12"
			y1="26.5"
			x2="47"
			y2="26.5"
			stroke="url(#brandGrad)"
			strokeWidth="0.9"
			strokeLinecap="round"
		  />
		</g>
  
		{/* передний сегмент кольца с анимацией «пробегающего» блика */}
		<g transform="rotate(-23.5 29.5 26.5)">
		  <ellipse
			cx="29.5"
			cy="26.5"
			rx="22.5"
			ry="6.4"
			fill="none"
			stroke="url(#brandGrad)"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeDasharray="28 400"
			strokeDashoffset="12"
			opacity="0.65"
		  >
			<animate
			  attributeName="stroke-dashoffset"
			  from="12"
			  to="-416"              /* 28 + 400 ≈ полный круг */
			  dur="6s"
			  repeatCount="indefinite"
			/>
		  </ellipse>
		</g>
	  </svg>
	);
  };
  
  
  

  const About3 = () => {
	return (
	  <svg
		width="70"
		height="60"
		viewBox="0 0 70 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	  >
		<g filter="url(#filter0_i_1802_1936)">
		  <path
			d="M39.9384 58.7613L66.4758 45.1476C67.7459 44.5125 68.3817 43.2895 68.3833 42.0658V40.3405H1V42.0658C1.00157 43.2895 1.63739 44.5125 2.90746 45.1476L29.4449 58.7613C32.7478 60.4128 36.6355 60.4128 39.9384 58.7613Z"
			fill="url(#paint0_linear_1802_1936)"
		  />
		</g>
		<g filter="url(#filter1_i_1802_1936)">
		  <path
			d="M29.4449 23.9854C32.7478 22.334 36.6355 22.334 39.9384 23.9854L66.4758 37.2541C69.0191 38.5258 69.0191 42.1552 66.4758 43.4268L39.9384 56.6955C36.6355 58.347 32.7478 58.347 29.4449 56.6955L2.90746 43.4268C0.364183 42.1552 0.364179 38.5258 2.90746 37.2541L29.4449 23.9854Z"
			fill="url(#paint1_radial_1802_1936)"
		  />
		</g>
		<g filter="url(#filter2_f_1802_1936)">
		  <path
			d="M39.9389 56.6953L66.4763 43.4266C67.634 42.8478 68.2647 41.7804 68.3685 40.6693C67.6081 42.4096 67.2927 42.5147 66.3313 43.0867L39.8567 56.1852C39.1029 56.5229 37.054 57.4006 34.5601 57.4006C32.0662 57.4006 30.1604 56.5229 29.4947 56.1852C20.9902 51.9248 3.72714 43.4971 2.90796 43.0607C2.08878 42.6243 1.36631 41.6404 1.10748 41.203C1.33731 42.1128 1.93747 42.9414 2.90796 43.4266L29.4454 56.6953C32.7483 58.3468 36.636 58.3468 39.9389 56.6953Z"
			fill="url(#paint2_linear_1802_1936)"
		  />
		</g>
		<g filter="url(#filter3_bi_1802_1936)">
		  <path
			d="M29.4449 12.612C32.7478 10.9606 36.6355 10.9605 39.9384 12.612L66.4758 25.8807C69.0191 27.1524 69.0191 30.7817 66.4758 32.0534L39.9384 45.3221C36.6355 46.9735 32.7478 46.9736 29.4449 45.3221L2.90746 32.0534C0.364183 30.7817 0.364179 27.1524 2.90746 25.8807L29.4449 12.612Z"
			fill="#E4E8F3"
			fillOpacity="0.4"
		  />
		</g>
		<g filter="url(#filter4_bi_1802_1936)">
		  <path
			d="M1 28.967V30.6924C1.00157 31.9161 1.63739 33.1391 2.90746 33.7741L29.4449 47.3879C32.7478 49.0394 36.6355 49.0394 39.9384 47.3879L66.4758 33.7741C67.7459 33.1391 68.3817 31.9161 68.3833 30.6924V28.9745C68.3807 30.1973 67.7449 31.4188 66.4758 32.0534L39.9384 45.3221C36.6355 46.9735 32.7478 46.9735 29.4449 45.3221L2.90746 32.0534C1.63582 31.4176 1 30.1923 1 28.967Z"
			fill="#E4E8F3"
			fillOpacity="0.4"
		  />
		</g>
		<g filter="url(#filter5_f_1802_1936)">
		  <path
			d="M39.9389 45.3219L66.4763 32.0532C67.634 31.4744 68.2647 30.407 68.3685 29.2959C67.6081 31.0362 67.2927 31.1413 66.3313 31.7133L39.8567 44.8118C39.1029 45.1495 37.054 46.0272 34.5601 46.0272C32.0662 46.0272 30.1604 45.1495 29.4947 44.8118C20.9902 40.5514 3.72714 32.1237 2.90796 31.6873C2.08878 31.2509 1.36631 30.2669 1.10748 29.8295C1.33731 30.7394 1.93747 31.568 2.90796 32.0532L29.4454 45.3219C32.7483 46.9734 36.636 46.9734 39.9389 45.3219Z"
			fill="url(#paint3_linear_1802_1936)"
		  />
		</g>
		<g filter="url(#filter6_bi_1802_1936)">
		  <path
			d="M29.4449 1.23859C32.7478 -0.412863 36.6355 -0.412866 39.9384 1.23859L66.4758 14.5073C69.0191 15.7789 69.0191 19.4083 66.4758 20.68L39.9384 33.9487C36.6355 35.6001 32.7478 35.6001 29.4449 33.9487L2.90746 20.68C0.364183 19.4083 0.364179 15.7789 2.90746 14.5073L29.4449 1.23859Z"
			fill="#E4E8F3"
			fillOpacity="0.4"
		  />
		</g>
		<g filter="url(#filter7_bi_1802_1936)">
		  <path
			d="M1 17.5936V19.3189C1.00157 20.5427 1.63739 21.7657 2.90746 22.4007L29.4449 36.0145C32.7478 37.666 36.6355 37.666 39.9384 36.0145L66.4758 22.4007C67.7459 21.7657 68.3817 20.5427 68.3833 19.3189V17.6011C68.3807 18.8239 67.7449 20.0454 66.4758 20.68L39.9384 33.9487C36.6355 35.6001 32.7478 35.6001 29.4449 33.9487L2.90746 20.68C1.63582 20.0441 1 18.8189 1 17.5936Z"
			fill="#E4E8F3"
			fillOpacity="0.4"
		  />
		</g>
		<g filter="url(#filter8_f_1802_1936)">
		  <path
			d="M39.9389 33.949L66.4763 20.6803C67.634 20.1015 68.2647 19.0341 68.3685 17.923C67.6081 19.6633 67.2927 19.7684 66.3313 20.3403L39.8567 33.4388C39.1029 33.7766 37.054 34.6543 34.5601 34.6543C32.0662 34.6543 30.1604 33.7766 29.4947 33.4388C20.9902 29.1784 3.72714 20.7508 2.90796 20.3144C2.08878 19.8779 1.36631 18.894 1.10748 18.4566C1.33731 19.3665 1.93747 20.195 2.90796 20.6803L29.4454 33.949C32.7483 35.6005 36.636 35.6005 39.9389 33.949Z"
			fill="url(#paint4_linear_1802_1936)"
		  />
		</g>
  
		{/* === ПУЛЬС: график + бегущая точка (свет) === */}
		<g clipPath="url(#pulseClipTopFace)">
		  {/* линия пульса */}
		  <path
			id="pulsePath"
			d="M6 21 L12 21 L16 19 L20 23 L23.5 21.5 L26 21 L30 17 L33 25 L37 21 L43 21 L47 19.5 L52 22.5 L64 21"
			fill="none"
			stroke="url(#pulseGrad)"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeDasharray="18 14"
			strokeDashoffset="220"
			opacity="0.95"
		  >
			<animate
			  attributeName="stroke-dashoffset"
			  from="220"
			  to="0"
			  dur="12.4s"
			  repeatCount="indefinite"
			/>
		  </path>
  
		  {/* бегущая «искра» по линии */}
		  <g filter="url(#pulseGlow)">
			<circle r="2.4" fill="url(#pulseGrad)">
			  <animateMotion dur="7.4s" repeatCount="indefinite" rotate="auto">
				<mpath href="#pulsePath" />
			  </animateMotion>
			</circle>
		  </g>
  
		  {/* маленькое пульс-кольцо вокруг искры */}
		  <circle r="0.8" fill="none" stroke="url(#pulseGrad)" strokeWidth="1.2" opacity="0.8">
			<animateMotion dur="12.4s" repeatCount="indefinite" rotate="auto">
			  <mpath href="#pulsePath" />
			</animateMotion>
			<animate attributeName="r" values="0.8;3;0.8" dur="0.8s" repeatCount="indefinite" />
			<animate attributeName="opacity" values="0.8;0;0.8" dur="0.8s" repeatCount="indefinite" />
		  </circle>
		</g>
  
		<defs>
		  {/* === ДОП. ОПРЕДЕЛЕНИЯ ДЛЯ ПУЛЬСА === */}
		  <linearGradient id="pulseGrad" x1="6" y1="20" x2="64" y2="22" gradientUnits="userSpaceOnUse">
			<stop stopColor="#ff8a3d" />
			<stop offset="1" stopColor="#ffffff" />
		  </linearGradient>
  
		  <filter id="pulseGlow" x="-20%" y="-20%" width="140%" height="140%">
			<feGaussianBlur stdDeviation="2.2" result="b" />
			<feMerge>
			  <feMergeNode in="b" />
			  <feMergeNode in="SourceGraphic" />
			</feMerge>
		  </filter>
  
		  {/* клип верхней грани, чтобы пульс был внутри */}
		  <clipPath id="pulseClipTopFace">
			<path d="M29.4449 1.23859C32.7478 -0.412863 36.6355 -0.412866 39.9384 1.23859L66.4758 14.5073C69.0191 15.7789 69.0191 19.4083 66.4758 20.68L39.9384 33.9487C36.6355 35.6001 32.7478 35.6001 29.4449 33.9487L2.90746 20.68C0.364183 19.4083 0.364179 15.7789 2.90746 14.5073L29.4449 1.23859Z" />
		  </clipPath>
  
		  {/* === исходные фильтры/градиенты (как в твоём коде) === */}
		  <filter
			id="filter0_i_1802_1936"
			x="1"
			y="39.8405"
			width="67.3833"
			height="20.1594"
			filterUnits="userSpaceOnUse"
			colorInterpolationFilters="sRGB"
		  >
			<feFlood floodOpacity="0" result="BackgroundImageFix" />
			<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
			<feColorMatrix
			  in="SourceAlpha"
			  type="matrix"
			  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
			  result="hardAlpha"
			/>
			<feOffset dy="-0.5" />
			<feGaussianBlur stdDeviation="0.5" />
			<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
			<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
			<feBlend mode="darken" in2="shape" result="effect1_innerShadow_1802_1936" />
		  </filter>
		  <filter
			id="filter1_i_1802_1936"
			x="1"
			y="22.7468"
			width="67.3833"
			height="35.6873"
			filterUnits="userSpaceOnUse"
			colorInterpolationFilters="sRGB"
		  >
			<feFlood floodOpacity="0" result="BackgroundImageFix" />
			<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
			<feColorMatrix
			  in="SourceAlpha"
			  type="matrix"
			  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
			  result="hardAlpha"
			/>
			<feOffset dy="0.5" />
			<feGaussianBlur stdDeviation="0.5" />
			<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
			<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
			<feBlend mode="darken" in2="shape" result="effect1_innerShadow_1802_1936" />
		  </filter>
		  <filter
			id="filter2_f_1802_1936"
			x="0.107475"
			y="39.6693"
			width="69.261"
			height="19.2646"
			filterUnits="userSpaceOnUse"
			colorInterpolationFilters="sRGB"
		  >
			<feFlood floodOpacity="0" result="BackgroundImageFix" />
			<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
			<feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_1802_1936" />
		  </filter>
		  <filter
			id="filter3_bi_1802_1936"
			x="-19"
			y="-8.62659"
			width="107.383"
			height="75.1873"
			filterUnits="userSpaceOnUse"
			colorInterpolationFilters="sRGB"
		  >
			<feFlood floodOpacity="0" result="BackgroundImageFix" />
			<feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
			<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1802_1936" />
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1802_1936" result="shape" />
			<feColorMatrix
			  in="SourceAlpha"
			  type="matrix"
			  values="0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"
			/>
			<feBlend mode="darken" in2="shape" result="effect2_innerShadow_1802_1936" />
		  </filter>
		  <filter
			id="filter4_bi_1802_1936"
			x="-19"
			y="8.96704"
			width="107.383"
			height="59.6594"
			filterUnits="userSpaceOnUse"
			colorInterpolationFilters="sRGB"
		  >
			<feFlood floodOpacity="0" result="BackgroundImageFix" />
			<feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
			<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1802_1936" />
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1802_1936" result="shape" />
			<feColorMatrix
			  in="SourceAlpha"
			  type="matrix"
			  values="0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
			/>
			<feBlend mode="darken" in2="shape" result="effect2_innerShadow_1802_1936" />
		  </filter>
		  <filter
			id="filter5_f_1802_1936"
			x="0.107475"
			y="28.2959"
			width="69.261"
			height="19.2646"
			filterUnits="userSpaceOnUse"
			colorInterpolationFilters="sRGB"
		  >
			<feFlood floodOpacity="0" result="BackgroundImageFix" />
			<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
			<feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_1802_1936" />
		  </filter>
		  <filter
			id="filter6_bi_1802_1936"
			x="-19"
			y="-20"
			width="107.383"
			height="75.1873"
			filterUnits="userSpaceOnUse"
			colorInterpolationFilters="sRGB"
		  >
			<feFlood floodOpacity="0" result="BackgroundImageFix" />
			<feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
			<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1802_1936" />
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1802_1936" result="shape" />
			<feColorMatrix
			  in="SourceAlpha"
			  type="matrix"
			  values="0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"
			/>
			<feBlend mode="darken" in2="shape" result="effect2_innerShadow_1802_1936" />
		  </filter>
		  <filter
			id="filter7_bi_1802_1936"
			x="-19"
			y="-2.40637"
			width="107.383"
			height="59.6594"
			filterUnits="userSpaceOnUse"
			colorInterpolationFilters="sRGB"
		  >
			<feFlood floodOpacity="0" result="BackgroundImageFix" />
			<feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
			<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1802_1936" />
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1802_1936" result="shape" />
			<feColorMatrix
			  in="SourceAlpha"
			  type="matrix"
			  values="0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"
			/>
			<feBlend mode="darken" in2="shape" result="effect2_innerShadow_1802_1936" />
		  </filter>
		  <filter
			id="filter8_f_1802_1936"
			x="0.107475"
			y="16.923"
			width="69.261"
			height="19.2646"
			filterUnits="userSpaceOnUse"
			colorInterpolationFilters="sRGB"
		  >
			<feFlood floodOpacity="0" result="BackgroundImageFix" />
			<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
			<feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_1802_1936" />
		  </filter>
		  <linearGradient
			id="paint0_linear_1802_1936"
			x1="1"
			y1="50.1702"
			x2="68.3833"
			y2="50.1702"
			gradientUnits="userSpaceOnUse"
		  >
			<stop stopColor="#6b7280" />
			<stop offset="1" stopColor="#6b7280" />
		  </linearGradient>
		  <radialGradient
			id="paint1_radial_1802_1936"
			cx="0"
			cy="0"
			r="1"
			gradientUnits="userSpaceOnUse"
			gradientTransform="translate(11.4 40.3405) scale(43.4779 43.4779)"
		  >
			<stop stopColor="#ff8a3d" />
			<stop offset="1" stopColor="white" />
		  </radialGradient>
		  <linearGradient
			id="paint2_linear_1802_1936"
			x1="1.10748"
			y1="40.6693"
			x2="68.3685"
			y2="40.6693"
			gradientUnits="userSpaceOnUse"
		  >
			<stop stopColor="white" stopOpacity="0.24" />
			<stop offset="0.130208" stopColor="white" stopOpacity="0.865636" />
			<stop offset="0.489583" stopColor="white" stopOpacity="0.494792" />
			<stop offset="1" stopColor="white" stopOpacity="0" />
		  </linearGradient>
		  <linearGradient
			id="paint3_linear_1802_1936"
			x1="1.10748"
			y1="29.2959"
			x2="68.3685"
			y2="29.2959"
			gradientUnits="userSpaceOnUse"
		  >
			<stop stopColor="white" stopOpacity="0.24" />
			<stop offset="0.130208" stopColor="white" stopOpacity="0.865636" />
			<stop offset="0.489583" stopColor="white" stopOpacity="0.494792" />
			<stop offset="1" stopColor="white" stopOpacity="0" />
		  </linearGradient>
		  <linearGradient
			id="paint4_linear_1802_1936"
			x1="1.10748"
			y1="17.923"
			x2="68.3685"
			y2="17.923"
			gradientUnits="userSpaceOnUse"
		  >
			<stop stopColor="white" stopOpacity="0.24" />
			<stop offset="0.130208" stopColor="white" stopOpacity="0.865636" />
			<stop offset="0.489583" stopColor="white" stopOpacity="0.494792" />
			<stop offset="1" stopColor="white" stopOpacity="0" />
		  </linearGradient>
		</defs>
	  </svg>
	);
  };
  
  const About4 = () => {
	return (
	  <svg
		width="70"
		height="60"
		viewBox="0 0 70 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		role="img"
		aria-label="VR — blinking label"
	  >
		{/* === БАЗА И СЛОИ (как у тебя), перекрашены в палитру === */}
		<g filter="url(#filter0_i_1802_2101)">
		  <path d="M43.8148 25.0492C43.8148 30.0348 39.8271 34.0764 34.908 34.0764C29.989 34.0764 26.0013 30.0348 26.0013 25.0492L1 22.7361V25.0492C0.999998 44.0294 16.1811 59.4158 34.908 59.4158C53.6349 59.4158 68.8161 44.0294 68.8161 25.0492V22.7361L43.8148 25.0492Z" fill="url(#paint0_linear_1802_2101)"/>
		</g>
		<g filter="url(#filter1_i_1802_2101)">
		  <path fillRule="evenodd" clipRule="evenodd" d="M34.9079 31.8492C39.8269 31.8492 43.8146 27.8076 43.8146 22.822L68.8159 22.822C68.8159 41.8022 53.6348 57.1886 34.9079 57.1886C16.181 57.1886 0.999831 41.8022 0.999832 22.822L26.0012 22.822C26.0012 27.8076 29.9888 31.8492 34.9079 31.8492Z" fill="url(#paint1_radial_1802_2101)"/>
		</g>
		<g filter="url(#filter2_f_1802_2101)">
		  <path d="M1.00155 22.7361H1C1 41.7162 16.1811 57.1027 34.908 57.1027C53.6349 57.1027 68.8161 41.7162 68.8161 22.7361H68.8145C68.6395 41.564 53.5261 56.607 34.908 56.607C16.29 56.607 1.17655 41.564 1.00155 22.7361Z" fill="url(#paint2_linear_1802_2101)"/>
		</g>
		<g filter="url(#filter3_bi_1802_2101)">
		  <path fillRule="evenodd" clipRule="evenodd" d="M34.908 21.2348C39.8271 21.2348 43.8148 17.1932 43.8148 12.2076L68.8161 12.2076C68.8161 31.1878 53.6349 46.5742 34.908 46.5742C16.1811 46.5742 0.999998 31.1878 1 12.2076L26.0013 12.2076C26.0013 17.1932 29.989 21.2348 34.908 21.2348Z" fill="#E4E8F3" fillOpacity="0.4"/>
		</g>
		<g filter="url(#filter4_bi_1802_2101)">
		  <path d="M0.999832 14.7277V12.4146C0.999831 31.3947 16.181 46.7811 34.9079 46.7811C53.6348 46.7811 68.8159 31.3947 68.8159 12.4146V14.7277C68.8159 33.7078 53.6348 49.0943 34.9079 49.0943C16.181 49.0943 0.999831 33.7078 0.999832 14.7277Z" fill="#E4E8F3" fillOpacity="0.4"/>
		</g>
		<g filter="url(#filter5_f_1802_2101)">
		  <path d="M1.00155 12.2076H1C1 31.1878 16.1811 46.5742 34.908 46.5742C53.6349 46.5742 68.8161 31.1878 68.8161 12.2076H68.8145C68.6395 31.0356 53.5261 46.0786 34.908 46.0786C16.29 46.0786 1.17655 31.0356 1.00155 12.2076Z" fill="url(#paint3_linear_1802_2101)"/>
		</g>
		<g filter="url(#filter6_bi_1802_2101)">
		  <path fillRule="evenodd" clipRule="evenodd" d="M34.908 10.0272C39.8271 10.0272 43.8148 5.98557 43.8148 1L68.8161 1.00001C68.8161 19.9801 53.6349 35.3666 34.908 35.3666C16.1811 35.3666 0.999998 19.9801 1 1L26.0013 1C26.0013 5.98557 29.989 10.0272 34.908 10.0272Z" fill="#E4E8F3" fillOpacity="0.4"/>
		</g>
		<g filter="url(#filter7_bi_1802_2101)">
		  <path d="M1 3.31313V1C0.999998 19.9801 16.1811 35.3666 34.908 35.3666C53.6349 35.3666 68.8161 19.9801 68.8161 1V3.31314C68.8161 22.2933 53.6349 37.6797 34.908 37.6797C16.1811 37.6797 0.999998 22.2933 1 3.31313Z" fill="#E4E8F3" fillOpacity="0.4"/>
		</g>
		<g filter="url(#filter8_f_1802_2101)">
		  <path d="M1.00155 1H1C1 19.9801 16.1811 35.3666 34.908 35.3666C53.6349 35.3666 68.8161 19.9801 68.8161 1.00001H68.8145C68.6395 19.828 53.5261 34.8709 34.908 34.8709C16.29 34.8709 1.17655 19.828 1.00155 1Z" fill="url(#paint4_linear_1802_2101)"/>
		</g>
  
		{/* === VR-ЛОГО: мигающий текст внутри верхней грани === */}
		<clipPath id="topFaceClip">
		  <path d="M29.4449 1.23859C32.7478 -0.412863 36.6355 -0.412866 39.9384 1.23859L66.4758 14.5073C69.0191 15.7789 69.0191 19.4083 66.4758 20.68L39.9384 33.9487C36.6355 35.6001 32.7478 35.6001 29.4449 33.9487L2.90746 20.68C0.364183 19.4083 0.364179 15.7789 2.90746 14.5073L29.4449 1.23859Z"/>
		</clipPath>
  
		<g clipPath="url(#topFaceClip)" filter="url(#vrGlow)">
		  <text
			x="50%"
			y="24.5"
			textAnchor="middle"
			dominantBaseline="middle"
			fontSize="16"
			fontWeight="800"
			fontFamily="Inter, system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
			fill="url(#vrTextGrad)"
			stroke="#6b7280"
			strokeWidth="0.6"
			letterSpacing="1.2"
		  >
			VR
			{/* мигаем: 2 сек выключено → 2 сек включено → повтор */}
			<animate
			  attributeName="opacity"
			  dur="4s"
			  repeatCount="indefinite"
			  keyTimes="0;0.5;1"
			  values="0;1;0"
			  calcMode="discrete"
			/>
		  </text>
		</g>
  
		{/* === ГРАДИЕНТЫ / ФИЛЬТРЫ === */}
		<defs>
		  {/* палитра */}
		  <linearGradient id="paint0_linear_1802_2101" x1="1" y1="24.0231" x2="68.8161" y2="24.0231">
			<stop stopColor="#6b7280"/><stop offset="1" stopColor="#6b7280"/>
		  </linearGradient>
		  <radialGradient id="paint1_radial_1802_2101" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
			gradientTransform="translate(3.11909 24.1438) scale(59.3391 60.1415)">
			<stop stopColor="#ff8a3d"/><stop offset="1" stopColor="#ffffff"/>
		  </radialGradient>
		  <linearGradient id="paint2_linear_1802_2101" x1="-1.05465" y1="-46.098" x2="70.871" y2="-46.098">
			<stop stopColor="white" stopOpacity="0.24"/><stop offset="0.130208" stopColor="white" stopOpacity="0.865636"/><stop offset="0.489583" stopColor="white" stopOpacity="0.494792"/><stop offset="1" stopColor="white" stopOpacity="0"/>
		  </linearGradient>
		  <linearGradient id="paint3_linear_1802_2101" x1="-1.05465" y1="-56.6264" x2="70.871" y2="-56.6264">
			<stop stopColor="white" stopOpacity="0.24"/><stop offset="0.130208" stopColor="white" stopOpacity="0.865636"/><stop offset="0.489583" stopColor="white" stopOpacity="0.494792"/><stop offset="1" stopColor="white" stopOpacity="0"/>
		  </linearGradient>
		  <linearGradient id="paint4_linear_1802_2101" x1="-1.05465" y1="-67.8341" x2="70.871" y2="-67.8341">
			<stop stopColor="white" stopOpacity="0.24"/><stop offset="0.130208" stopColor="white" stopOpacity="0.865636"/><stop offset="0.489583" stopColor="white" stopOpacity="0.494792"/><stop offset="1" stopColor="white" stopOpacity="0"/>
		  </linearGradient>
  
		  {/* градиент заливки текста */}
		  <linearGradient id="vrTextGrad" x1="18" y1="18" x2="52" y2="30" gradientUnits="userSpaceOnUse">
			<stop stopColor="#ff8a3d"/><stop offset="1" stopColor="#ffffff"/>
		  </linearGradient>
  
		  {/* лёгкое свечение текста */}
		  <filter id="vrGlow" x="-10%" y="-10%" width="120%" height="120%" colorInterpolationFilters="sRGB">
			<feGaussianBlur in="SourceAlpha" stdDeviation="1.2" result="b"/>
			<feMerge>
			  <feMergeNode in="b"/><feMergeNode in="SourceGraphic"/>
			</feMerge>
		  </filter>
  
		  {/* системные фильтры из твоего исходника */}
		  <filter id="filter0_i_1802_2101" x="1" y="22.2361" width="67.8161" height="37.1797" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
			<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
			<feOffset dy="-0.5"/><feGaussianBlur stdDeviation="0.5"/><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
			<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend mode="darken" in2="shape" result="effect1_innerShadow_1802_2101"/>
		  </filter>
		  <filter id="filter1_i_1802_2101" x="0.999832" y="22.822" width="67.8161" height="34.8666" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
			<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
			<feOffset dy="0.5"/><feGaussianBlur stdDeviation="0.5"/><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
			<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="darken" in2="shape" result="effect1_innerShadow_1802_2101"/>
		  </filter>
		  <filter id="filter2_f_1802_2101" x="0" y="21.7361" width="69.8161" height="36.3666" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_1802_2101"/>
		  </filter>
		  <filter id="filter3_bi_1802_2101" x="-19" y="-7.79236" width="107.816" height="74.3666" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="10"/>
			<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1802_2101"/>
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1802_2101" result="shape"/>
			<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"/>
			<feBlend mode="darken" in2="shape" result="effect2_innerShadow_1802_2101"/>
		  </filter>
		  <filter id="filter4_bi_1802_2101" x="-19.0002" y="-7.58545" width="107.816" height="76.6797" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="10"/>
			<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1802_2101"/>
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1802_2101" result="shape"/>
			<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"/>
			<feBlend mode="darken" in2="shape" result="effect2_innerShadow_1802_2101"/>
		  </filter>
		  <filter id="filter5_f_1802_2101" x="0" y="11.2076" width="69.8161" height="36.3666" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_1802_2101"/>
		  </filter>
		  <filter id="filter6_bi_1802_2101" x="-19" y="-19" width="107.816" height="74.3666" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="10"/>
			<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1802_2101"/>
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1802_2101" result="shape"/>
			<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0.342674 0 0 0 0 0.352133 0 0 0 0 0.579167 0 0 0 0.1 0"/>
			<feBlend mode="darken" in2="shape" result="effect2_innerShadow_1802_2101"/>
		  </filter>
		  <filter id="filter7_bi_1802_2101" x="-19" y="-19" width="107.816" height="76.6797" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="10"/>
			<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1802_2101"/>
			<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1802_2101" result="shape"/>
			<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0.341176 0 0 0 0 0.352941 0 0 0 0 0.580392 0 0 0 0.25 0"/>
			<feBlend mode="darken" in2="shape" result="effect2_innerShadow_1802_2101"/>
		  </filter>
		  <filter id="filter8_f_1802_2101" x="0" y="0" width="69.8161" height="36.3666" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
			<feFlood floodOpacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_1802_2101"/>
		  </filter>
		</defs>
	  </svg>
	);
  };


const telegramIcon = () => {
	return (
		<svg
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clip-path='url(#clip0_1802_2117)'>
				<path
					fill-rule='evenodd'
					clip-rule='evenodd'
					d='M26.3693 5.90662C26.6988 5.76794 27.0595 5.72011 27.4137 5.76811C27.768 5.81611 28.1029 5.95818 28.3836 6.17953C28.6643 6.40089 28.8805 6.69344 29.0098 7.02673C29.1391 7.36002 29.1767 7.72187 29.1187 8.07462L26.0946 26.4173C25.8013 28.1866 23.86 29.2013 22.2373 28.32C20.88 27.5826 18.864 26.4466 17.0507 25.2613C16.144 24.668 13.3667 22.768 13.708 21.416C14.0013 20.26 18.668 15.916 21.3347 13.3333C22.3813 12.3186 21.904 11.7333 20.668 12.6666C17.5987 14.984 12.6707 18.508 11.0413 19.5C9.60399 20.3746 8.85465 20.524 7.95865 20.3746C6.32399 20.1026 4.80799 19.6813 3.57065 19.168C1.89865 18.4746 1.97999 16.176 3.56932 15.5066L26.3693 5.90662Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_1802_2117'>
					<rect width='32' height='32' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
const planetIcon = () => {
	return (
		<svg
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M20.4296 13.844C20.5062 14.5943 20.55 15.3204 20.55 16C20.55 17.2722 20.3962 18.7087 20.1611 20.1611C18.7087 20.3962 17.2722 20.55 16 20.55C14.7336 20.55 13.2975 20.3967 11.8388 20.1606C11.6037 18.7083 11.45 17.272 11.45 16C11.45 15.3207 11.4939 14.5945 11.5705 13.844C13.1014 14.0891 14.6287 14.25 16 14.25C17.3714 14.25 18.8986 14.0891 20.4296 13.844Z'
				fill='currentColor'
			/>
			<path
				d='M22.5003 13.4659C22.595 14.3439 22.65 15.1987 22.65 16C22.65 17.1692 22.533 18.4519 22.3466 19.7537C24.99 19.2021 27.4334 18.4974 28.7422 18.0963C29.1653 17.9666 29.3314 17.9151 29.5544 17.8259C29.6658 17.7813 29.768 17.736 29.9011 17.6724C29.9664 17.124 30 16.5659 30 16C30 14.504 29.7654 13.0629 29.3309 11.7113L29.2177 11.7469C27.8491 12.1633 25.2869 12.8993 22.5003 13.4659Z'
				fill='currentColor'
			/>
			<path
				d='M28.5355 9.7593C27.1597 10.1763 24.772 10.8539 22.2132 11.3814C21.6238 7.79901 20.5906 4.22601 20.0936 2.60797C23.7897 3.73636 26.8364 6.35289 28.5355 9.7593Z'
				fill='currentColor'
			/>
			<path
				d='M20.1489 11.7631C18.7004 11.9971 17.2685 12.15 16 12.15C14.7316 12.15 13.2997 11.9971 11.8512 11.7631C12.4063 8.3734 13.3971 4.91074 13.9037 3.25777C14.0334 2.83475 14.0849 2.66859 14.1741 2.44557C14.2187 2.33416 14.264 2.23197 14.3276 2.09885C14.876 2.03358 15.4341 2 16 2C16.5912 2 17.1738 2.03664 17.7457 2.10778C17.7579 2.15418 17.7691 2.19572 17.7802 2.23501C17.8129 2.35111 17.8642 2.51427 17.9504 2.78805L17.9594 2.81681C18.3913 4.18964 19.5358 8.01869 20.1489 11.7631Z'
				fill='currentColor'
			/>
			<path
				d='M9.78672 11.3813C10.3735 7.81476 11.3998 4.26102 11.8959 2.64241L11.9064 2.60796C8.21036 3.73633 5.1636 6.35287 3.46446 9.75928C4.84024 10.1762 7.22794 10.8538 9.78672 11.3813Z'
				fill='currentColor'
			/>
			<path
				d='M2.66912 11.7113C2.23464 13.0628 2 14.504 2 16C2 16.5852 2.03591 17.1621 2.10564 17.7284L2.32628 17.802L2.32803 17.8026L2.3302 17.8033L2.33172 17.8038C2.40274 17.8273 4.48407 18.5146 7.22504 19.1966C7.99848 19.389 8.81743 19.5792 9.65341 19.7535C9.467 18.4518 9.35 17.1692 9.35 16C9.35 15.1985 9.40498 14.3436 9.49963 13.4659C6.71237 12.8992 4.14958 12.1628 2.78129 11.7465L2.77177 11.7436L2.66912 11.7113Z'
				fill='currentColor'
			/>
			<path
				d='M16 22.65C17.1692 22.65 18.4519 22.533 19.7537 22.3466C19.2021 24.9899 18.4974 27.4334 18.0963 28.7422C17.9667 29.1652 17.9151 29.3314 17.8259 29.5544C17.7813 29.6658 17.736 29.768 17.6724 29.9011C17.124 29.9664 16.5659 30 16 30C15.4341 30 14.876 29.9664 14.3276 29.9011C14.264 29.768 14.2187 29.6658 14.1741 29.5544C14.0849 29.3314 14.0334 29.1653 13.9037 28.7422C13.5026 27.4335 12.7979 24.9903 12.2464 22.347C13.5439 22.5328 14.8267 22.65 16 22.65Z'
				fill='currentColor'
			/>
			<path
				d='M6.71801 21.2345C4.98471 20.8032 3.50847 20.37 2.60795 20.0935C3.96344 24.5336 7.46643 28.0365 11.9064 29.392L11.8959 29.3576C11.4627 27.9443 10.6253 25.0556 10.0292 21.9712C8.87001 21.747 7.74297 21.4895 6.71801 21.2345Z'
				fill='currentColor'
			/>
			<path
				d='M29.3576 20.1041C27.9442 20.5373 25.0554 21.3748 21.9709 21.9709C21.3748 25.0553 20.5373 27.9442 20.1041 29.3576L20.0936 29.392C24.5336 28.0365 28.0366 24.5336 29.392 20.0936L29.3576 20.1041Z'
				fill='currentColor'
			/>
			<path
				d='M2.14707 17.7639C2.19553 17.7703 2.23503 17.7769 2.24814 17.7799C2.25963 17.7827 2.27761 17.7874 2.28414 17.7892L2.29855 17.7934L2.3063 17.7957L2.31447 17.7982L2.32131 17.8004C2.31746 17.7992 2.23968 17.7797 2.14707 17.7639Z'
				fill='currentColor'
			/>
		</svg>
	);
};




const SoccerBall = () => {
	return (
		<svg 
			width='24' 
			height='24' 
			viewBox='0 0 122.88 122.88' 
			fill='none' 
			xmlns='http://www.w3.org/2000/svg'
		>
			<path 
				fillRule='evenodd' 
				clipRule='evenodd'
				fill='white'
				d='M61.44,0c16.97,0,32.33,6.88,43.44,18c11.12,11.12,18,26.48,18,43.44c0,16.97-6.88,32.33-18,43.44 c-11.12,11.12-26.48,18-43.44,18S29.11,116,18,104.88C6.88,93.77,0,78.41,0,61.44C0,44.47,6.88,29.11,18,18 C29.11,6.88,44.47,0,61.44,0L61.44,0z M76.85,117.08L76.73,117l6.89-23.09L69.41,78.15L52.66,78L39.38,94.62l6.66,22.32l-0.15,0.1 c4.95,1.38,10.16,2.12,15.55,2.12C66.78,119.16,71.95,118.44,76.85,117.08L76.85,117.08z M12.22,91.61l24.34,0.12L49.28,75.8 l-5.26-16.12l-21.42-9.3L3.78,64.08C4.23,74.14,7.26,83.53,12.22,91.61L12.22,91.61z M16.77,24.88l7.4,22.14l19.98,8.68 l15.44-11.97V20.94L40.51,7.63c-7.52,2.93-14.28,7.39-19.89,13C19.27,21.98,17.98,23.4,16.77,24.88L16.77,24.88z M81.7,7.37 L63.3,20.77V43.7L77.8,54.91l20.81-8.92l7.18-21.49c-1.12-1.35-2.3-2.64-3.54-3.88C96.48,14.85,89.49,10.29,81.7,7.37L81.7,7.37z M119.09,64.36l-0.02,0.01L99.09,49.82l-19.81,8.49l-6.08,18.03l13.73,15.23c0.06,0.06,0.09,0.13,0.11,0.21l23.6-0.11 C115.56,83.65,118.59,74.34,119.09,64.36L119.09,64.36z'
			/>
		</svg>
	);
};


const Ball = () => {
	return (
		<svg
			width='200'
			height='200'
			viewBox='0 0 208 148'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d="M107.908 130.194l4.408-3.801-2.408-1.953c-1.324-1.074-3.033-2.747-3.797-3.716-1.307-1.66-.983-1.726 5.508-1.123l6.896.641 4.993-6.307c2.746-3.469 6.351-8.811 8.012-11.871L134.539 96.5 129.019 91 123.5 85.5l8.834-.29 8.834-.29 3.27-7.21C146.237 73.744 148.087 69.6 148.55 68.5c.62-1.474 1.094.04 1.8 5.75 1.053 8.507 1.333 8.745 7.336 6.237 1.992-.832 3.858-1.277 4.147-.987.918.918-2.627 7.267-6.373 11.413-3.502 3.877-3.593 4.173-2.922 9.544.787 6.301.096 6.767-5.835 3.938-3.2-1.526-3.705-1.483-10.284.879l-6.919 2.484-.304 5.756-.304 5.756 6.121-.693c3.367-.381 6.879-.927 7.804-1.214.925-.287-.343 1.381-2.818 3.706-7.117 6.686-22.942 12.878-33 12.913l-3.5.012zm-16.742 2.032c-.734-.247-3.365-3.207-5.847-6.579-4.457-6.055-4.595-6.144-11.166-7.283C70.494 117.73 66.15 116.673 64.5 116.015l-3-1.196 6.314-2.306c3.473-1.269 6.575-2.568 6.894-2.887.319-.319-.78-3.628-2.443-7.353-2.454-5.5-3.844-7.275-7.394-9.444-2.404-1.469-4.705-2.707-5.113-2.75-.407-.043-2.138 2.397-3.845 5.422-1.707 3.025-3.502 5.5-3.989 5.5-1.661 0-2.178-5.132-1.142-11.322L51.816 83.5 48.158 80.323 44.5 77.146l4-1.597C54.78 73.041 55.012 72.816 57.328 67c2.351-5.905 4.005-6.754 4.446-2.281.723 7.329.331 7.077 8.953 5.758 4.274-.654 10.247-2.375 13.272-3.824 3.025-1.449 5.996-2.639 6.602-2.644.678-.006 1.359-3.665 1.769-9.496l.667-9.486-3.605-5.43-3.606-5.43-5.616 1.932c-3.089 1.063-6.028 1.795-6.53 1.628-.502-.167 1.225-2.505 3.839-5.194 4.535-4.667 4.701-5.033 3.616-8.032-2.16-5.975-1.714-6.71 3.594-5.914 2.602.39 5.864 1.027 7.25 1.416 1.623.455 3.765.095 6.02-1.013 4.324-2.124 9.26-3.632 14.5-4.431l4-.61-5.5 4.942-5.5 4.942 6.5 2.83 6.5 2.83-4.5.679c-2.475.374-6.663.713-9.306.754-4.721.073-4.842.155-6.822 4.632-3.71 8.387-3.581 10.508 1.053 17.331 2.283 3.361 4.471 6.106 4.863 6.1.392-.006 2.963-.698 5.713-1.539 7.394-2.261 12.503-3.322 12.481-2.593-.011.354-2.509 3.958-5.551 8.008-4.823 6.421-5.358 7.574-4.175 9 .746.899 3.482 4.06 6.079 7.024 2.597 2.964 4.519 5.592 4.271 5.84-.248.249-4.171-.489-8.718-1.639C109.339 81.941 105.275 81 104.854 81c-.421 0-2.651 3.175-4.957 7.057-3.759 6.327-5.615 12.702-6.877 23.616-.011.095 2.447 1.716 5.462 3.602 3.015 1.886 5.19 3.72 4.833 4.077C102.958 119.708 100.512 120 97.879 120h-4.788l-.296 6.337c-.222 4.75-.63 6.225-1.63 5.889zm-1.692-31.834c3.19-2.598 5.441-5.171 5.162-5.899-.551-1.435-2.467-11.676-2.874-15.361-.214-1.933-1.603-2.899-7.565-5.26l-7.304-2.892-3.379 2.577c-1.858 1.418-4.487 4.03-5.841 5.805l-2.462 3.228 2.072 6.32c1.821 5.554 2.809 6.908 8.145 11.171 3.34 2.668 6.594 4.866 7.231 4.885.637.019 3.704-2.04 6.815-4.574zm54.172-41.267l-4.854-7.375-5.604.659c-3.082.362-6.712.937-8.067 1.277-2.407.604-2.386.513.958-4.059 1.881-2.572 3.871-5.379 4.421-6.237.793-1.237-.32-2.782-5.387-7.474-7.203-6.671-6.647-7.246 4.258-4.406 5.605 1.46 7.628 1.327 7.628-.502 0-.482.484-2.143 1.075-3.691l1.075-2.815 1.412 2.5c.777 1.375 2.118 4.84 2.981 7.701.927 3.071 2.276 5.425 3.295 5.748.949.301 4.186 3.063 7.193 6.137L159.5 52.175l-5.213-.337L149.074 51.5l-.287 7.5L148.5 66.5zm-101.053-9.25c1.153-6.453 8.511-20.074 13.749-25.452 2.696-2.768 5.088-4.847 5.316-4.619.228.228-.245 2.602-1.049 5.276-1.985 6.607-2.006 6.555 2.627 6.555h4.09l-5.006 3.957c-4.896 3.87-5.021 4.104-5.725 10.673l-.718 6.717-2.864-3.423L55.002 53.5l-3.515 3.75C49.555 59.313 47.704 61 47.375 61c-.329 0-.296-1.688.072-3.75z"
				fill="currentColor"
			/>
		</svg>
	);
};

const Stade = ({ size = 110 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 512 512"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M511.827,319.302c-1.651,2.486-3.402,4.953-5.32,7.364C455.808,390.172,373.073,402.938,256,402.938
				c-117.057,0-199.792-12.766-250.491-76.265c-1.918-2.418-3.669-4.886-5.337-7.372c-1.001,39.066,1.868,74.055,21.763,100.464
				C66.514,478.97,141.361,492.219,256,492.219c114.655,0,189.502-13.25,234.097-72.453
				C509.976,393.357,512.828,358.368,511.827,319.302z"
				fill="currentColor"
			/>
			<path
				d="M256,381.925c114.638,0,189.502-12.499,234.08-68.359c31.303-39.216,19.112-95.31,1.601-143.757
				c-18.895-52.241-32.454-86.354-71.862-114.713C380.411,26.736,316.921,19.781,256,19.781c-60.906,0-124.395,6.955-163.82,35.314
				c-39.391,28.36-52.95,62.472-71.845,114.713c-17.51,48.448-29.702,104.541,1.601,143.757
				C66.514,369.426,141.361,381.925,256,381.925z M203.417,294.228l4.002-32.062h97.161l4.019,32.062H203.417z M214.523,78.801h82.952
				l3.235,25.908h-89.423L214.523,78.801z M127.803,93.119c3.018-9.164,11.574-15.359,21.214-15.359h49.414l-5.387,43.06h125.912
				l-1.134-9.055l-4.253-34.004h49.415c9.656,0,18.211,6.195,21.23,15.359l23.598,71.762H306.449c-1.185-2.969-2.752-5.72-4.704-8.122
				c-5.137-6.329-12.291-10.623-20.179-13.459c-7.905-2.826-16.677-4.194-25.566-4.202c-11.824,0.025-23.481,2.41-33.155,7.546
				c-4.819,2.586-9.155,5.896-12.574,10.115c-1.951,2.402-3.519,5.153-4.703,8.122H104.204L127.803,93.119z M290.388,180.982
				c-2.118,2.877-6.47,5.987-12.524,8.164c-6.07,2.234-13.725,3.56-21.864,3.552c-10.84,0.025-20.83-2.394-27.367-6.021
				c-3.235-1.776-5.587-3.794-7.004-5.695H290.388z M224.73,164.881c2.686-2.502,6.472-4.761,11.141-6.421
				c5.87-2.102,12.942-3.26,20.13-3.252c9.589-0.026,18.978,2.084,25.566,5.636c2.268,1.218,4.186,2.586,5.737,4.036H224.73z
				 M71.267,265.085l27.651-84.103h105.233c0.833,3.478,2.385,6.721,4.469,9.498c4.787,6.412,11.874,10.799,19.996,13.792
				c8.172,2.977,17.528,4.52,27.384,4.527c13.158-0.024,25.416-2.718,35.122-8.012c4.853-2.661,9.089-6.021,12.274-10.307
				c2.068-2.777,3.636-6.02,4.47-9.498h105.232l27.651,84.103c2.235,6.813,1.068,14.276-3.135,20.071
				c-4.186,5.804-10.907,9.24-18.078,9.24h-94.692l-6.038-48.331H193.21l-6.037,48.331H92.481c-7.155,0-13.892-3.436-18.095-9.24
				C70.183,279.361,69.033,271.898,71.267,265.085z"
				fill="currentColor"
			/>
		</svg>
	);
};


const Logotip = ({ size = 102 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 500.44443 500.44443"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			{/* Основная форма - серый силуэт */}
			<path
				d="m 244.96293,376.11979 c -0.26143,-0.42299 -1.83274,-0.98936 -3.49181,-1.25859 -7.15165,-1.16055 -28.46209,-11.13861 -39.536,-18.5117 -6.62146,-4.40862 -15.55528,-12.94408 -14.81013,-14.14976 0.20225,-0.32725 4.48187,-0.83379 9.51026,-1.12564 9.55415,-0.55452 20.5304,-3.2367 30.47585,-7.44714 2.93334,-1.24184 7.05257,-2.86968 9.15385,-3.61742 l 3.82052,-1.35954 -2.04274,-2.325 -2.04274,-2.32501 2.39523,2.10871 c 1.68811,1.48617 3.00021,1.94448 4.44445,1.5524 2.09071,-0.56759 21.68898,-14.20694 25.46509,-17.72234 l 2.08255,-1.93877 -0.53942,4 c -1.13689,8.43043 -2.29234,27.36797 -2.29234,37.57083 v 10.64601 l 2,-1.43439 c 3.50213,-2.5117 5.76349,-3.52022 3.33333,-1.4866 -1.22222,1.02279 -4.26694,2.85253 -6.76603,4.06609 -2.49909,1.21356 -5.65215,3.23365 -7.00679,4.48909 -2.47155,2.29055 -6.47934,4.35769 -7.84881,4.04826 -0.403,-0.0911 -0.52695,0.1674 -0.27545,0.57435 0.25151,0.40695 -0.51876,1.47288 -1.7117,2.36875 -1.19295,0.89587 -2.169,1.95529 -2.169,2.35429 0,0.39899 2.9,0.86348 6.44445,1.0322 l 6.44444,0.30677 -7.28087,0.17662 c -4.00448,0.0971 -7.49477,-0.16947 -7.75619,-0.59247 z"
				fill="#a9a9aa"
			/>
			
			{/* Средние детали - коричневый/оранжевый */}
			<path
				d="m 250.44997,371.85389 c 0.61416,-0.2476 0.85236,-0.87783 0.52933,-1.4005 -0.3338,-0.5401 -0.17085,-0.69291 0.37749,-0.35402 0.53064,0.32795 1.21605,0.18976 1.52313,-0.30711 0.30708,-0.49686 1.03472,-0.89449 1.61698,-0.88362 0.58225,0.0109 0.0587,0.80198 -1.16358,1.75801 -1.22222,0.95604 -2.62222,1.71557 -3.11111,1.68784 -0.48889,-0.0277 -0.38639,-0.25299 0.22776,-0.5006 z"
				fill="#dd9d56"
			/>
			
			{/* Яркие акценты - оранжевый */}
			<path
				d="m 328.90839,343.96353 c 0.51256,-0.95773 1.31785,-1.74132 1.78954,-1.74132 0.47169,0 0.85761,-0.62361 0.85761,-1.38579 0,-0.8876 -0.39944,-1.13534 -1.11111,-0.68912 -0.61111,0.38317 -2.61111,0.80037 -4.44444,0.92712 l -3.33333,0.23046 v -3.59977 c 0,-5.76776 -3.98483,-11.4829 -8.00635,-11.4829 -2.10818,0 -2.31179,-0.27686 -1.96104,-2.66667 0.21526,-1.46666 0.76959,-2.66666 1.23185,-2.66666 0.46225,0 0.61956,-0.35742 0.34957,-0.79427 -0.26998,-0.43685 1.50641,-2.92165 3.94754,-5.52178 2.44113,-2.60013 4.43843,-5.25527 4.43843,-5.9003 0,-0.64503 0.55591,-1.3861 1.23535,-1.64683 1.86024,-0.71384 9.29903,-10.63361 9.96556,-13.28926 0.32087,-1.27846 1.10085,-2.52304 1.73329,-2.76573 0.63243,-0.24268 1.81574,-2.11038 2.62957,-4.15043 0.81382,-2.04005 2.8449,-4.96313 4.51351,-6.49573 2.33673,-2.14628 3.03383,-3.49683 3.03383,-5.87777 0,-2.12088 0.86482,-4.17594 2.75506,-6.54678 2.97834,-3.73559 6.13382,-9.43025 6.13382,-11.06961 0,-0.56002 1.00012,-2.20678 2.22249,-3.65948 1.22236,-1.4527 2.44493,-3.71044 2.71682,-5.0172 1.53654,-7.38506 2.61164,-9.89492 5.64618,-13.18131 l 3.34889,-3.62682 1.09426,16.54943 c 1.43105,21.64298 1.4269,19.58737 0.0622,30.77165 -0.88141,7.22348 -1.92373,11.40324 -3.98996,16 -1.53828,3.42222 -3.07289,7.32222 -3.41025,8.66666 -0.33735,1.34445 -1.00575,2.44445 -1.48533,2.44445 -0.47957,0 -0.87195,0.45576 -0.87195,1.0128 0,0.55704 -1.11911,2.85704 -2.48691,5.11111 -1.36779,2.25407 -2.97062,5.75416 -3.56184,7.77797 -0.59121,2.02382 -2.01074,4.29284 -3.15451,5.04226 -1.14377,0.74942 -2.56732,2.5401 -3.16344,3.97928 -0.59613,1.43918 -2.05749,3.13776 -3.24748,3.77461 -1.18998,0.63686 -2.1636,1.90024 -2.1636,2.8075 0,0.91627 -0.93398,2.00468 -2.10099,2.44837 -1.15555,0.43934 -2.31266,1.3504 -2.57137,2.02459 -0.25871,0.67418 -2.51856,2.28842 -5.02188,3.58719 -4.07126,2.11224 -4.45318,2.17767 -3.61958,0.62008 z"
				fill="#eaa131"
			/>
			
			{/* Красные детали */}
			<path
				d="m 247.1111,375.37252 c 0,-0.49369 2.3,-2.36695 5.11111,-4.16278 2.81111,-1.79584 6.91111,-4.62614 9.11111,-6.28955 2.2,-1.66342 4.47818,-3.05095 5.06262,-3.08341 1.84932,-0.10271 15.6905,-11.78874 29.12519,-24.59025 7.13288,-6.79671 13.5833,-12.49173 14.33425,-12.65561 2.10777,-0.45997 0.0263,2.24586 -5.35761,6.96462 -2.5101,2.2 -5.65602,5.51527 -6.99095,7.36726 -1.33492,1.85199 -3.06724,3.61289 -3.84959,3.91311 -0.78235,0.30022 -3.03047,2.07551 -4.99581,3.94509 -1.96534,1.86959 -4.31817,3.63565 -5.2285,3.92458 -0.91033,0.28892 -1.65515,0.88809 -1.65515,1.33148 0,0.44339 -1.19323,1.42321 -2.65162,2.17737 -1.45839,0.75416 -3.26867,2.56443 -4.02283,4.02283 -0.75416,1.45839 -1.80542,2.65162 -2.33613,2.65162 -0.53071,0 -2.83504,1.56574 -5.12073,3.47944 -2.2857,1.91369 -5.62362,4.17939 -7.41762,5.03488 -2.7275,1.30066 -4.9451,3.70076 -4.02755,4.359 0.13373,0.0959 3.84315,-0.1856 8.24315,-0.62563 11.67951,-1.16805 24.11788,-4.03769 30.31226,-6.9933 2.98285,-1.42325 6.42445,-2.58773 7.64798,-2.58773 1.22353,0 3.30362,-1 4.62242,-2.22222 1.3188,-1.22222 2.87721,-2.23112 3.46313,-2.24199 0.58592,-0.0109 2.06531,-0.80197 3.28754,-1.75801 1.22222,-0.95603 3.02222,-1.71556 4,-1.68784 1.23604,0.035 1.38383,0.20549 0.48498,0.55932 -0.71103,0.27989 -2.11103,1.28224 -3.11111,2.22743 -2.61851,2.47481 -16.72053,9.0131 -24.31205,11.2721 -13.95093,4.15135 -43.72849,8.01119 -43.72849,5.66819 z"
				fill="#dc6351"
			/>
			
			{/* Ярко-красные акценты */}
			<path
				d="m 256.0136,373.61544 c 0.0268,-1.42948 1.36772,-2.72511 4.43084,-4.28112 1.71111,-0.86921 4.96662,-3.12503 7.23447,-5.01292 2.26784,-1.88789 4.55757,-3.43252 5.08828,-3.43252 0.53071,0 1.58197,-1.19323 2.33613,-2.65162 0.75416,-1.4584 2.56444,-3.26867 4.02283,-4.02283 1.45839,-0.75416 2.65162,-1.73398 2.65162,-2.17737 0,-0.44339 0.74482,-1.04256 1.65515,-1.33148 0.91033,-0.28893 3.26316,-2.05499 5.2285,-3.92458 1.96534,-1.86958 4.17821,-3.63135 4.91748,-3.91503 0.73927,-0.28369 2.48644,-2.02242 3.88261,-3.86385 3.18841,-4.20528 9.45129,-10.03521 12.45387,-11.59297 6.43612,-3.3391 12.75128,1.76004 12.75128,10.29596 v 3.59977 l 3.33333,-0.23046 c 1.83333,-0.12675 3.83333,-0.54395 4.44444,-0.92712 1.5669,-0.98246 1.39099,0.86862 -0.26054,2.74158 -0.75441,0.85555 -3.17423,3.85291 -5.37738,6.66078 -2.45097,3.12373 -4.9374,5.33033 -6.40612,5.68518 -1.32022,0.31898 -3.46215,1.32162 -4.75984,2.22811 -1.29769,0.90648 -2.77708,1.64815 -3.28754,1.64815 -0.51045,0 -2.00711,1 -3.32591,2.22222 -1.3188,1.22222 -3.39889,2.22222 -4.62242,2.22222 -1.22353,0 -4.66513,1.16448 -7.64798,2.58773 -6.18158,2.94951 -19.17281,5.9764 -28.97893,6.75195 -3.66667,0.28999 -7.36667,0.73415 -8.22222,0.98702 -0.85556,0.25288 -1.54943,0.13281 -1.54195,-0.2668 z"
				fill="#f26133"
			/>
			
			{/* Темные части - серые */}
			<path
				d="m 231.1111,320.32989 c -5.13333,-4.15703 -13.28961,-11.40417 -18.12505,-16.10475 -9.06116,-8.80844 -23.90673,-26.04522 -23.11443,-26.83752 0.24599,-0.24599 0.80622,0.13355 1.24495,0.84343 2.83891,4.59347 18.43388,22.09501 25.33789,28.43561 2.92782,2.68889 5.52331,5.11055 5.76775,5.38148 0.50256,0.55701 13.4959,10.92261 17.42682,13.90247 1.41525,1.07284 2.17318,1.94767 1.6843,1.94407 -0.48889,-0.004 -5.08889,-3.40775 -10.22223,-7.56479 z"
				fill="#595a63"
			/>
			
			{/* Самые темные части - почти черный */}
			<path
				d="m 239.1111,325.49912 c -4.00517,-3.03428 -16.30868,-12.845 -16.88889,-13.46707 -0.24444,-0.26208 -2.83993,-2.6765 -5.76775,-5.36539 -5.20278,-4.7782 -18.25131,-19.07379 -22.67669,-24.84392 -1.22222,-1.59363 -2.62921,-3.35568 -3.12665,-3.91568 -4.90681,-5.52394 -18.89036,-29.13878 -21.41974,-36.17275 -0.87042,-2.42054 -1.90356,-4.40098 -2.29587,-4.40098 -0.39231,0 -0.71329,-0.92 -0.71329,-2.04445 0,-1.12444 -0.34768,-2.42444 -0.77262,-2.88889 -0.42493,-0.46444 -1.65319,-4.64444 -2.72947,-9.28889 -2.86383,-12.35834 -2.76805,-12.2021 -7.53871,-12.29785 -3.33933,-0.067 -4.31708,0.29257 -5.43517,1.999 -1.4558,2.22182 -2.90661,6.45023 -3.65825,10.66201 -0.25377,1.42195 -0.78065,3.42509 -1.17086,4.4514 -0.3902,1.02632 -1.2199,5.47248 -1.84377,9.88037 -1.0989,7.76417 -1.05965,8.27458 1.25737,16.35211 2.07982,7.25061 9.5293,24.57028 11.11501,25.84185 0.30483,0.24444 1.49402,1.78205 2.64264,3.4169 1.81521,2.58362 1.99289,3.51385 1.35833,7.11111 -0.86041,4.87752 -0.93345,5.79294 -1.09866,13.76979 l -0.12584,6.07558 -3.66457,-6.96447 c -2.01551,-3.83046 -3.95198,-7.36447 -4.30326,-7.85335 -1.04427,-1.45333 -5.32951,-13.66043 -6.35494,-18.10293 -1.84245,-7.98209 -3.09962,-25.50001 -2.4392,-33.98889 1.29048,-16.58768 3.92277,-26.77543 10.12259,-39.17751 12.50401,-25.01289 29.7101,-41.9168 55.00592,-54.03988 4.93173,-2.36354 10.96679,-4.9653 13.41123,-5.78169 8.19698,-2.73759 21.24819,-5.02586 31.57054,-5.53527 11.37876,-0.56154 27.54057,0.36284 27.54057,1.57519 0,0.43071 -1.16904,1.38764 -2.59788,2.12652 -1.42883,0.73888 -4.45316,2.94915 -6.72073,4.91172 l -4.12284,3.5683 -8.61261,0.003 c -23.48017,0.008 -46.95878,8.31193 -64.23344,22.71883 -7.54053,6.28873 -8.22943,7.69741 -9.76906,19.9762 -1.66458,13.27533 3.26401,35.79649 11.1681,51.03252 7.3768,14.21963 19.10082,30.87705 28.63887,40.68995 6.59323,6.78321 8.86063,7.94775 10.64319,5.46636 0.65764,-0.91547 1.87199,-2.46449 2.69856,-3.44226 1.84077,-2.17753 8.24118,-12.62764 8.24118,-13.45559 0,-0.32936 1,-1.9099 2.22222,-3.51231 1.22222,-1.60242 2.22222,-3.10321 2.22222,-3.33509 0,-0.23187 1.85765,-4.35856 4.12811,-9.17041 2.27046,-4.81186 5.41289,-12.65792 6.98316,-17.43569 1.57028,-4.77778 3.05409,-8.88591 3.29736,-9.12917 1.27015,-1.27015 39.57561,12.73869 52.57924,19.22896 6.21732,3.10314 10.36399,6.23696 8.92499,6.74502 -0.53682,0.18952 -4.22687,2.23152 -8.20013,4.53777 -9.33361,5.41762 -24.1553,17.21121 -30.3794,24.17283 -2.68889,3.00751 -5.88989,6.5742 -7.11333,7.92598 -1.22344,1.35178 -4.10901,5.26668 -6.41238,8.69979 -4.52037,6.7375 -8.88256,10.35278 -28.94543,23.98927 -1.24892,0.84888 -2.09851,0.60759 -4.63997,-1.31779 z"
				fill="#10172a"
			/>
		</svg>
	);
};




const Icons = {
	Facebook,
	TG,
	Discord,
	Hamburger,
	MacroChip,
	MicroChip,
	Rocket,
	About1,
	About2,
	About3,
	About4,
	telegramIcon,
	planetIcon,
	Logotip,
	SoccerBall,
	Ball,
	Stade,
};

export default Icons;
